import { __decorate, __spread, __values, __metadata, __extends, __param, __assign } from 'tslib';
import { NgModule, Renderer2, ElementRef, Input, HostListener, Component, Directive, EventEmitter, Output, ɵɵdefineInjectable, Injectable, ChangeDetectorRef, ChangeDetectionStrategy, ContentChildren, QueryList, Injector, Optional, SkipSelf, NgZone, ɵɵinject, ViewChild, TemplateRef, ComponentFactoryResolver, INJECTOR, InjectionToken, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatAutocompleteModule, MatBadgeModule, MatBottomSheetModule, MatButtonModule, MatButtonToggleModule, MatCardModule, MatCheckboxModule, MatChipsModule, MatDatepickerModule, MatDialogModule, MatDividerModule, MatExpansionModule, MatGridListModule, MatIconModule, MatInputModule, MatListModule, MatMenuModule, MatNativeDateModule, MatPaginatorModule, MatProgressBarModule, MatProgressSpinnerModule, MatRadioModule, MatRippleModule, MatSelectModule, MatSidenavModule, MatSliderModule, MatSlideToggleModule, MatSnackBarModule, MatSortModule, MatStepperModule, MatTableModule, MatTabsModule, MatToolbarModule, MatTooltipModule, MatTreeModule, MatDialogConfig, MatDialog } from '@angular/material';
import { interval, of, Subject, from, BehaviorSubject, ReplaySubject, merge, fromEvent } from 'rxjs';
import { tap, take, map, catchError, takeUntil, throttleTime, filter } from 'rxjs/operators';
import { MatButtonModule as MatButtonModule$1 } from '@angular/material/button';
import { forOwn, includes } from 'lodash';
import { CognitoUserPool, CognitoUser, AuthenticationDetails, CognitoUserAttribute } from 'amazon-cognito-identity-js';
import { MatDialog as MatDialog$1 } from '@angular/material/dialog';
import { pie, arc, select, interpolate } from 'd3';
import { OverlayContainer } from '@angular/cdk/overlay';
import { FormsModule } from '@angular/forms';

var MATERIAL_MODULES = [
    MatAutocompleteModule,
    MatBadgeModule,
    MatBottomSheetModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatDatepickerModule,
    MatDialogModule,
    MatDividerModule,
    MatExpansionModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatStepperModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    MatTreeModule,
];
var UbiMaterialModule = /** @class */ (function () {
    function UbiMaterialModule() {
    }
    UbiMaterialModule = __decorate([
        NgModule({
            imports: __spread([
                CommonModule
            ], MATERIAL_MODULES),
            declarations: [],
            exports: __spread(MATERIAL_MODULES)
        })
    ], UbiMaterialModule);
    return UbiMaterialModule;
}());

var CurveHeaderComponent = /** @class */ (function () {
    // tslint:disable-next-line:use-life-cycle-interface
    // ngDoCheck(): void {
    //   if (
    //     this.svg && (
    //       this.oldHeight !== this.hostElement.nativeElement.offsetHeight ||
    //       this.oldWidth !== this.hostElement.nativeElement.offsetWidth)) {
    //     this.fixedSizeForeignObject(this.svg.querySelector('foreignObject'));
    //     clearInterval(this.interval);
    //   }
    // }
    function CurveHeaderComponent(renderer, hostElement) {
        this.renderer = renderer;
        this.hostElement = hostElement;
        this.adaptive = true;
        this.size = 'large';
        // @ViewChild('content') content: ElementRef;
        this.loca = location;
        this.localtionName = location.pathname.replace(/\//g, '_');
        this.smallPath = 'M 704 0.5 H 0 V 84 C 0 84 71 118.5 159 118.5 C 247 118.5 431 55.5 538.5 55.5 C 646 55.5 704 84 704 84 V 0.5 Z';
        this.bigPath = 'M0 94.6392V0H1509V94.6392C1182.41 35.4045 963.604 24.7185 617.807 66.6695C408.502 92.0617 288.505 132.27 0 94.6392Z';
        this.currentPath = this.bigPath;
        this.breakpoint = 900;
        this.svg = null;
        this.foreignObjectInfo = [];
        this.oldHeight = 0;
        this.oldWidth = 0;
        this.interval = null;
        this.offset = 0.5;
        renderer.addClass(hostElement.nativeElement, 'ubi-curve-header');
        // this.updateStyle();
    }
    CurveHeaderComponent.prototype.updateOffset = function () {
        if (this.size === 'small') {
            this.bigPath = this.smallPath;
        }
        if (this.svg) {
            if (this.offsetTop) {
                this.svg.setAttribute('style', "min-height: " + (90 - parseInt(this.offsetTop, 10)) + "px; " +
                    ("max-height: " + (90 - parseInt(this.offsetTop, 10)) + " px"));
            }
            else {
                var content = document.querySelector('foreignObject').children[0];
                var height = content.offsetHeight + 50;
                this.svg.setAttribute('style', "min-height: " + height + "px; " +
                    ("max-height: " + height + "px"));
            }
        }
    };
    CurveHeaderComponent.prototype.resize = function (event) {
        var w = this.hostElement.nativeElement.clientWidth;
        // if (w <= this.breakpoint && this.currentPath !== this.smallPath) {
        //   this.currentPath = this.smallPath;
        //   this.hostElement.nativeElement.innerHTML = this.buildSvg(this.currentPath);
        //   this.svg = this.hostElement.nativeElement.getElementsByTagName('svg')[0];
        // } else if (w > this.breakpoint && this.currentPath !== this.bigPath) {
        //   this.currentPath = this.bigPath;
        //   this.hostElement.nativeElement.innerHTML = this.buildSvg(this.currentPath);
        //   this.svg = this.hostElement.nativeElement.getElementsByTagName('svg')[0];
        // }
        if (!this.adaptive) {
            this.svg.setAttribute('style', 'min-height:50px');
        }
        if (w <= this.breakpoint && this.adaptive) {
            this.svg.setAttribute('preserveAspectRatio', 'xMinYMax slice');
        }
        else {
            this.svg.setAttribute('preserveAspectRatio', 'none');
        }
        this.updateOffset();
        this.calculateSVGScale(this.svg);
        this.fixScale(this.foreignObjectInfo);
    };
    CurveHeaderComponent.prototype.ngAfterContentInit = function () {
        if (this.svg) {
            this.fixedSizeForeignObject(this.svg.querySelector('foreignObject'));
            this.svg.querySelector('foreignObject').style.visibility = 'visible';
        }
    };
    CurveHeaderComponent.prototype.buildSvg = function (svgPath) {
        // const height = this.hostElement.nativeElement.offsetHeight;
        // tslint:disable-next-line:max-line-length
        // this.hostElement.nativeElement.innerHTML += `< svg style = "margin-top:-${height}px" class="ubi-curve-header__place-holder" viewBox = "0 0 1509 110" fill = "none" width = "100%" xmlns = "http://www.w3.org/2000/svg" preserveAspectRatio = "none" > <path d='M0 94.6392V0H1509V94.6392C1182.41 35.4045 963.604 24.7185 617.807 66.6695C408.502 92.0617 288.505 132.27 0 94.6392Z' fill = 'url(#paint0_linear)' /> <defs><linearGradient id='paint0_linear' x1 = '-96.8688' y1 = '61.4216' x2 = '1739.74' y2 = '100.845' gradientUnits = 'userSpaceOnUse' > <stop offset='0.106004' stop - color='#4FAF97' /> <stop offset='0.509133' stop - color='#9FC566' /> <stop offset='0.839574' stop - color='#4FAF97' /> </linearGradient></defs > </svg>`;
        var content = this.hostElement.nativeElement.innerHTML;
        this.hostElement.nativeElement.innerHTML = '';
        // tslint:disable-next-line:max-line-length
        var imageElement = this.image ? "<image preserveAspectRatio=\"xMidYMid meet\" xmlns=\"http://www.w3.org/2000/xlink\" xlink:href=\"" + this.image + "\" x=\"80%\" y=\"10\" height=\"300\" width=\"300\"  clip-path=\"url(" + location.pathname + "#myClip)\" />" : '';
        var html = "<svg viewBox=\"0 0 1509 110\" preserveAspectRatio=\"none\"  fill=\"none\" width=\"100%\" xmlns=\"http://www.w3.org/2000/svg\" >\n\n    <path style=\"visibility:hidden\" d=\"" + svgPath + "\" fill=\"url(" + location.pathname + "#" + location.pathname.replace(/\//g, '_') + "paint0_linear\"/>\n    <foreignObject style=\"visibility:hidden\" x=\"0\" y=\"0\" width=\"1509\" height=\"110\" transform=\"\">\n        " + content + "\n    </foreignObject>\n    <clipPath id=\"myClip\">\n      <path style=\"visibility:hidden\"  id=\"curve\" d=\"" + svgPath + "\"/>\n    </clipPath>\n    " + imageElement + "\n    <defs>\n      <linearGradient id=\"" + location.pathname.replace(/\//g, '_') + "paint0_linear\" x1=\"-96\" y1=\"61\" x2=\"1739\" y2=\"100\" gradientUnits=\"userSpaceOnUse\">\n        <stop offset=\"0.1\" stop-color=\"#4FAF97\"/>\n        <stop offset=\"0.5\" stop-color=\"#9FC566\"/>\n        <stop offset=\"0.8\" stop-color=\"#4FAF97\"/>\n      </linearGradient>\n    </defs>\n    </svg>";
        // if (this.icon) {
        html += '';
        // }
        // if (this.image) {
        //   this.imageObject = new Image();
        //   this.imageObject.onload = this.imageOnLoad.bind(this);
        //   this.imageObject.src = this.image;
        // }
        return html;
    };
    CurveHeaderComponent.prototype.ngOnInit = function () {
        var _this = this;
        // this.hostElement.nativeElement.innerHTML = this.buildSvg(this.bigPath);
        // const w = this.hostElement.nativeElement.clientWidth;
        // const h = this.hostElement.nativeElement.clientHeight;
        // console.log(this.content.nativeElement.clientHeight);
        this.svg = this.hostElement.nativeElement.getElementsByTagName('svg')[0];
        interval(0).pipe(tap(function () {
            var w = _this.hostElement.nativeElement.clientWidth;
            var h = _this.hostElement.nativeElement.clientHeight;
            // if (w <= this.breakpoint) {
            //   this.hostElement.nativeElement.innerHTML = this.buildSvg(this.smallPath);
            // } else {
            //   this.hostElement.nativeElement.innerHTML = this.buildSvg(this.bigPath);
            // }
            _this.updateOffset();
            if (!_this.adaptive) {
                _this.svg.setAttribute('style', 'min-height:50px');
            }
            if (w <= _this.breakpoint && _this.adaptive) {
                _this.svg.setAttribute('preserveAspectRatio', 'xMinYMax slice');
            }
            else {
                _this.svg.setAttribute('preserveAspectRatio', 'none');
            }
            if (w > 0) {
                _this.svg.querySelector('path').style.visibility = 'visible';
            }
            if (_this.svg.querySelector('foreignObject') && w > 0) {
                _this.fixedSizeForeignObject(_this.svg.querySelector('foreignObject'));
            }
        }), take(5)).subscribe();
    };
    // imageOnLoad() {
    //   console.log(this.imageObject.width);
    //   this.fixedSizeForeignObject(this.svg.querySelector('image'), true, this.imageObject.width, this.imageObject.height, 0, 0);
    // }
    CurveHeaderComponent.prototype.updateStyle = function () {
        // this.renderer.setStyle(this.hostElement.nativeElement, 'background-position', `${this.offsetLeft}px ${this.offsetTop}px`);
    };
    CurveHeaderComponent.prototype.ngOnChanges = function (changes) {
        // this.updateStyle();
    };
    CurveHeaderComponent.prototype.fixedSizeForeignObject = function (el, noTranslate, w, h, x, y) {
        if (noTranslate === void 0) { noTranslate = false; }
        if (w === void 0) { w = 1509; }
        if (h === void 0) { h = this.offsetTop || 90; }
        if (x === void 0) { x = null; }
        if (y === void 0) { y = null; }
        var info = {
            el: el, svg: this.svg,
            // w: el.getAttribute('width') * 1, h: el.getAttribute('height') * 1,
            w: w, h: h,
            noTranslate: noTranslate,
            x: x || el.getAttribute('x') * 1, y: y || el.getAttribute('y') * 1
        };
        this.foreignObjectInfo.push(info);
        if (!info.noTranslate) {
            el.removeAttribute('x');
            el.removeAttribute('y');
        }
        this.calculateSVGScale(this.svg);
        this.fixScale(this.foreignObjectInfo);
        this.svg.querySelector('foreignObject').style.visibility = 'visible';
    };
    CurveHeaderComponent.prototype.calculateSVGScale = function (svg) {
        var w1 = svg.viewBox.animVal.width, h1 = svg.viewBox.animVal.height;
        if (!w1 && !h1) {
            svg.scaleRatios = [1, 1]; // No viewBox
        }
        else {
            var info = getComputedStyle(svg);
            var w2 = parseFloat(info.width), h2 = parseFloat(info.height);
            var par = svg.preserveAspectRatio.animVal;
            if (w2 && h2) {
                if (par.align === SVGPreserveAspectRatio.SVG_PRESERVEASPECTRATIO_NONE) {
                    svg.scaleRatios = [w2 / w1, h2 / h1];
                }
                else {
                    var meet = par.meetOrSlice === SVGPreserveAspectRatio.SVG_MEETORSLICE_MEET;
                    var ratio = (w1 / h1 > w2 / h2) !== meet ? h2 / h1 : w2 / w1;
                    svg.scaleRatios = [ratio, ratio];
                }
            }
            else {
                svg.scaleRatios = [1, 1]; // No viewBox
            }
        }
    };
    CurveHeaderComponent.prototype.fixScale = function (infos) {
        var e_1, _a;
        try {
            for (var infos_1 = __values(infos), infos_1_1 = infos_1.next(); !infos_1_1.done; infos_1_1 = infos_1.next()) {
                var info = infos_1_1.value;
                var h1 = this.svg.height.baseVal.value;
                var s = info.svg.scaleRatios;
                info.el.setAttribute('width', info.w * s[0]);
                info.el.setAttribute('height', info.h * s[1]);
                if (info.noTranslate) {
                    info.el.setAttribute('transform', 'scale(' + 1 / s[0] + ',' + 1 / s[1] + ')');
                }
                else {
                    var content = document.querySelector('foreignObject').children[0];
                    info.el.setAttribute('transform', 'translate(' + info.x + ',' + ((h1 / 2 + 6) - (content.offsetHeight / 2)) + ') scale(' + 1 / s[0] + ',' + 1 / s[1] + ')');
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (infos_1_1 && !infos_1_1.done && (_a = infos_1.return)) _a.call(infos_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    CurveHeaderComponent.ctorParameters = function () { return [
        { type: Renderer2 },
        { type: ElementRef }
    ]; };
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], CurveHeaderComponent.prototype, "offsetLeft", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], CurveHeaderComponent.prototype, "offsetTop", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], CurveHeaderComponent.prototype, "titleClass", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], CurveHeaderComponent.prototype, "adaptive", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], CurveHeaderComponent.prototype, "size", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], CurveHeaderComponent.prototype, "image", void 0);
    __decorate([
        HostListener('window:resize', ['$event']),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], CurveHeaderComponent.prototype, "resize", null);
    CurveHeaderComponent = __decorate([
        Component({
            // tslint:disable-next-line:component-selector
            selector: '[ubi-curve-header]',
            template: "<svg viewBox=\"0 0 1509 110\" preserveAspectRatio=\"none\" fill=\"none\" width=\"100%\" xmlns=\"http://www.w3.org/2000/svg\">\n  <path style=\"visibility:hidden\" [attr.d]=\"bigPath\"\n    [attr.fill]=\"'url('+loca.pathname+'#'+localtionName+'paint0_linear'\" />\n  <foreignObject style=\"visibility:hidden\" x=\"0\" y=\"0\" width=\"1509\" height=\"110\" transform=\"\">\n    <ng-content #content></ng-content>\n  </foreignObject>\n  <clipPath id=\"myClip\">\n    <path style=\"visibility:hidden\" id=\"curve\" [attr.d]=\"bigPath\" />\n  </clipPath>\n    <image preserveAspectRatio=\"xMidYMid meet\" xmlns=\"http://www.w3.org/2000/xlink\" [attr.xlink:href]=\"image\" x=\"80%\" y=\"10\"\n      height=\"300\" width=\"300\" [attr.clip-path]=\"'url('+loca.pathname+'#myClip)'\" />\n  <defs>\n    <linearGradient [attr.id]=\"localtionName+'paint0_linear'\" x1=\"-96\" y1=\"61\" x2=\"1739\" y2=\"100\"\n      gradientUnits=\"userSpaceOnUse\">\n      <stop offset=\"0.1\" stop-color=\"#4FAF97\" />\n      <stop offset=\"0.5\" stop-color=\"#9FC566\" />\n      <stop offset=\"0.8\" stop-color=\"#4FAF97\" />\n    </linearGradient>\n  </defs>\n</svg>\n"
        }),
        __metadata("design:paramtypes", [Renderer2, ElementRef])
    ], CurveHeaderComponent);
    return CurveHeaderComponent;
}());

var RoundButtonDirective = /** @class */ (function () {
    function RoundButtonDirective(renderer, hostElement) {
        this.renderer = renderer;
        renderer.addClass(hostElement.nativeElement, 'ubi-round-button');
    }
    RoundButtonDirective.ctorParameters = function () { return [
        { type: Renderer2 },
        { type: ElementRef }
    ]; };
    RoundButtonDirective = __decorate([
        Directive({
            // tslint:disable-next-line:directive-selector
            selector: '[ubi-round-button]'
        }),
        __metadata("design:paramtypes", [Renderer2, ElementRef])
    ], RoundButtonDirective);
    return RoundButtonDirective;
}());

var UberUiModule = /** @class */ (function () {
    function UberUiModule() {
    }
    UberUiModule = __decorate([
        NgModule({
            imports: [
                UbiMaterialModule
            ],
            exports: [
                UbiMaterialModule,
                CurveHeaderComponent,
                RoundButtonDirective
            ],
            declarations: [
                CurveHeaderComponent,
                RoundButtonDirective
            ]
        })
    ], UberUiModule);
    return UberUiModule;
}());

var UbiPaginationComponent = /** @class */ (function () {
    function UbiPaginationComponent() {
        this.currentPage = 1;
        this.itemPerPage = 5;
        this.change = new EventEmitter();
    }
    Object.defineProperty(UbiPaginationComponent.prototype, "total", {
        set: function (total) {
            this._total = total;
            this.pages = this.calculatePages(total);
        },
        enumerable: true,
        configurable: true
    });
    UbiPaginationComponent.prototype.ngOnInit = function () {
    };
    UbiPaginationComponent.prototype.numberOfPages = function (total) {
        return Math.ceil(total / this.itemPerPage);
    };
    UbiPaginationComponent.prototype.calculatePages = function (total) {
        this.totalPage = this.numberOfPages(total);
        var pages = [];
        if (this.totalPage > 1) {
            this.hasNextPage = true;
            for (var i = 1; i <= this.totalPage; i++) {
                pages.push(i);
            }
            return pages;
        }
        return [1];
    };
    UbiPaginationComponent.prototype.getPage = function (page) {
        this.currentPage = page;
        this.hasPreviousPage = this.currentPage > 1 ? true : false;
        this.hasNextPage = this.currentPage <= this.totalPage - 1;
        this.change.emit(page);
    };
    /**
     * If the current is one of the fist page few pages, we will show page numbers for:
     * The first 6 pages / the last 2 pages / 2 pages before and after the current page
     */
    /**
     * If the current page is one of the last few pages, then we will show page numbers for:
     * The first 2 pages / the last 6 pages / 2 pages before and after the current page
     */
    /**
     * If the current page is in the middle, then we will show page numbers for:
     * The first 2 pages / the last 2 pages / 2 pages before and after the current page
     */
    UbiPaginationComponent.prototype.isShowPage = function (page) {
        if (this.currentPage < 6) {
            return (page <= 6)
                || (page > this._total - 2)
                || ((page < this.currentPage + 2) && (page > this.currentPage - 2));
        }
        else if (this.currentPage > this._total - 5) {
            return (page <= 2)
                || (page >= this._total - 5)
                || ((page < this.currentPage + 2) && (page > this.currentPage - 2));
        }
        else {
            return (page <= 2)
                || (page > this._total - 2)
                || ((page < this.currentPage + 2) && (page > this.currentPage - 2));
        }
    };
    // If it eceeds the number of pages, `...` will be shown at the specified locations
    UbiPaginationComponent.prototype.isShowEllipsis = function (page) {
        return ((page === 3) || (page === this._total - 2))
            && !this.isShowPage(page);
    };
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], UbiPaginationComponent.prototype, "currentPage", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], UbiPaginationComponent.prototype, "itemPerPage", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Number),
        __metadata("design:paramtypes", [Number])
    ], UbiPaginationComponent.prototype, "total", null);
    __decorate([
        Output(),
        __metadata("design:type", Object)
    ], UbiPaginationComponent.prototype, "change", void 0);
    UbiPaginationComponent = __decorate([
        Component({
            selector: 'ubi-pagination',
            template: "<ng-container *ngIf=\"hasNextPage || hasPreviousPage\">\n  <div class=\"page\">\n    <button class=\"page__button page__button-prev\" *ngIf=\"hasPreviousPage\" (click)=\"getPage(currentPage -1)\">\n      <i class=\"material-icons\">\n        keyboard_arrow_left\n      </i>\n    </button>\n    <ul class=\"pagination\">\n      <ng-container *ngFor=\"let page of pages\">\n        <li class=\"page__item\" *ngIf=\"isShowPage(page)\" [class.active]=\"currentPage === page\">\n          <span class=\"page__link\" (click)=\"getPage(page)\">{{page}}</span>\n        </li>\n        <span *ngIf=\"isShowEllipsis(page)\">...</span>\n      </ng-container>\n    </ul>\n    <button class=\"page__button page__button-next\" *ngIf=\"hasNextPage\" (click)=\"getPage(currentPage + 1)\">\n      <i class=\"material-icons\">\n        keyboard_arrow_right\n      </i>\n    </button>\n  </div>\n</ng-container>\n",
            styles: [":host /deep/{display:block}:host /deep/ .page{display:-webkit-box;display:flex;-webkit-box-pack:end;justify-content:flex-end;-webkit-box-align:center;align-items:center;padding:0 15px}:host /deep/ .page .pagination{display:-webkit-box;display:flex;-webkit-box-pack:end;justify-content:flex-end;-webkit-box-align:center;align-items:center;margin:0;padding:0;list-style:none}:host /deep/ .page__item{padding:12px;cursor:pointer}:host /deep/ .page__item:hover span{color:#ffb15c}:host /deep/ .page__item.active{color:#ffb15c}:host /deep/ .page__item.active span{opacity:1}:host /deep/ .page__link{display:block;font-weight:400;font-size:.8rem;opacity:.8}:host /deep/ .page__button{margin-top:4px;border:0;padding:0;outline:0;background:0 0;cursor:pointer}:host /deep/ .page__button i{font-size:1.3rem}:host /deep/ .page__button i:hover{color:#ffb15c}@media (max-width:767px){:host /deep/ .page{margin:15px 0;padding:0}:host /deep/ .page__item{margin:5px;min-width:30px;height:30px;border:1px solid;padding:0;text-align:center;line-height:30px}:host /deep/ .page__button{margin-top:0}:host /deep/ .page__button .material-icons{display:-webkit-box;display:flex;-webkit-box-pack:center;justify-content:center;-webkit-box-align:center;align-items:center;margin-top:0;min-width:30px;height:30px;border:1px solid}:host /deep/ .page__button-next{margin-left:5px}:host /deep/ .page__button-prev{margin-right:5px}}"]
        }),
        __metadata("design:paramtypes", [])
    ], UbiPaginationComponent);
    return UbiPaginationComponent;
}());

var UbiPaginationModule = /** @class */ (function () {
    function UbiPaginationModule() {
    }
    UbiPaginationModule = __decorate([
        NgModule({
            imports: [
                CommonModule,
                MatButtonModule$1
            ],
            exports: [UbiPaginationComponent],
            declarations: [UbiPaginationComponent]
        })
    ], UbiPaginationModule);
    return UbiPaginationModule;
}());

var UbiPieChartComponent = /** @class */ (function () {
    function UbiPieChartComponent() {
        this.title = 'Completed';
        this.titleColor = '#606060';
        this.thumbColor = '#FFB15B';
        this.dotColor = '#ffb15c';
        this.backgroundColor = '#d0d0d0';
        this.value = 25;
    }
    UbiPieChartComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (this.pieConfig) {
            forOwn(this.pieConfig, function (value, key) {
                _this[key] = value;
            });
        }
    };
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], UbiPieChartComponent.prototype, "value", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], UbiPieChartComponent.prototype, "pieConfig", void 0);
    UbiPieChartComponent = __decorate([
        Component({
            selector: 'ubi-pie-chart',
            template: "<div class=\"pie\">\n  <svg viewBox=\"-1 -1 38 38\" class=\"circular-chart orange\">\n\n    <defs>\n      <linearGradient x1=\"83.6895384%\" y1=\"30.075307%\" x2=\"6.62452473%\" y2=\"70.5659932%\" id=\"linearGradient\">\n        <stop stop-color=\"#546E7B\" offset=\"0%\"></stop>\n        <stop [ngStyle]=\"{'stop-color': thumbColor}\" offset=\"100%\"></stop>\n      </linearGradient>\n    </defs>\n\n    <path class=\"pie-bg\" [ngStyle]=\"{'stroke': backgroundColor}\" stroke-width=\"1.5\" d=\"M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831\" />\n\n    <path class=\"pie-box\" [attr.stroke-dashoffset]=\"100 - value\" stroke=\"#eae5e5\" opacity=\"0.2\" stroke-dasharray=\"0,100\" d=\"M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831\" />\n\n    <path class=\"pie-thumb\" [attr.stroke-dasharray]=\"value + ',100'\" d=\"M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831\" />\n\n    <path class=\"pie-dot\" [attr.stroke-dashoffset]=\"100 - value\" [ngStyle]=\"{'stroke': dotColor}\" stroke-dasharray=\"0,100\" d=\"M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831\" />\n\n    <text x=\"18\" y=\"20.35\" class=\"percentage\">{{value}}<tspan [ngStyle]=\"{'fill': dotColor}\" font-size=\"5\">%</tspan></text>\n\n    <text x=\"18\" y=\"24.35\" class=\"text\" text-anchor=\"middle\" font-size=\"2\" [ngStyle]=\"{'fill': titleColor}\">\n      {{title}}\n    </text>\n  </svg>\n</div>\n",
            styles: [":host /deep/{display:block}:host /deep/ .pie{margin:20px 0;text-align:center}:host /deep/ .pie .text{letter-spacing:.2em;text-transform:uppercase}:host /deep/ .circular-chart{width:220px;fill:none}:host /deep/ .pie-bg{fill:none;opacity:.5}:host /deep/ .pie-thumb{fill:none;stroke-width:1.5;stroke-linecap:round;-webkit-animation:1s ease-out forwards progress;animation:1s ease-out forwards progress;stroke:url(#linearGradient) #ffb15b}:host /deep/ .pie-dot{fill:none;stroke-width:3;stroke-linecap:round;-webkit-animation:1s ease-out forwards progress1;animation:1s ease-out forwards progress1}:host /deep/ .pie-box{fill:none;stroke-width:5;stroke-linecap:round;-webkit-animation:1s ease-out forwards progress1;animation:1s ease-out forwards progress1;opacity:.9}:host /deep/ .percentage{font-weight:700;font-size:10px;text-anchor:middle;fill:#ffb15c}@-webkit-keyframes progress{0%{stroke-dasharray:0 100}}@keyframes progress{0%{stroke-dasharray:0 100}}@-webkit-keyframes progress1{0%{stroke-dashoffset:100}}@keyframes progress1{0%{stroke-dashoffset:100}}"]
        })
    ], UbiPieChartComponent);
    return UbiPieChartComponent;
}());

var UbiPieChartModule = /** @class */ (function () {
    function UbiPieChartModule() {
    }
    UbiPieChartModule = __decorate([
        NgModule({
            imports: [
                CommonModule
            ],
            exports: [UbiPieChartComponent],
            declarations: [UbiPieChartComponent]
        })
    ], UbiPieChartModule);
    return UbiPieChartModule;
}());

var StepperEventType;
(function (StepperEventType) {
    StepperEventType["CHANGE"] = "CHANGE";
})(StepperEventType || (StepperEventType = {}));
var UbiStepperService = /** @class */ (function () {
    function UbiStepperService() {
        this._active$ = new EventEmitter();
        this._event$ = new EventEmitter();
    }
    /**
     * Set the UbiStepperComponent into the service
     * @param instance UbiStepperComponent
     */
    UbiStepperService.prototype.setInstance = function (instance) {
        this._instance = instance;
    };
    /**
     * Get current instance
     */
    UbiStepperService.prototype.getInstace = function () {
        return this._instance;
    };
    /**
     * Get current step
     */
    UbiStepperService.prototype.currentStep = function () {
        return this._currentStep;
    };
    /**
     * Change Event when the step has chosen.
     */
    UbiStepperService.prototype.change = function () {
        return this._event$;
    };
    /**
     * Set current step
     * @param item number | UbiStepComponent
     */
    UbiStepperService.prototype.setCurrentStep = function (item) {
        this._instance.steps.forEach(function (i) { return i.isActive = false; });
        var index;
        if (typeof item === 'number') {
            this._currentStep = this._instance.steps.find(function (element, i) { return i === item; });
            index = item;
        }
        else {
            this._currentStep = this._instance.steps.find(function (element, i) { return element === item; });
            index = this._instance.steps.toArray().indexOf(this._currentStep);
        }
        this._currentStep.isActive = true;
        this._event$.next({
            type: StepperEventType.CHANGE,
            data: {
                index: index
            }
        });
    };
    /**
     * Set the step to completed state
     * @param index number
     * @param isCompleted Boolean
     */
    UbiStepperService.prototype.setStepComplete = function (index, isCompleted) {
        this._instance.steps.find(function (item, i) { return i === index; }).isCompleted = isCompleted;
    };
    UbiStepperService.ngInjectableDef = ɵɵdefineInjectable({ factory: function UbiStepperService_Factory() { return new UbiStepperService(); }, token: UbiStepperService, providedIn: "root" });
    UbiStepperService = __decorate([
        Injectable({
            providedIn: 'root'
        }),
        __metadata("design:paramtypes", [])
    ], UbiStepperService);
    return UbiStepperService;
}());

var UbiStepComponent = /** @class */ (function () {
    function UbiStepComponent(cdRef, stepperService) {
        this.cdRef = cdRef;
        this.stepperService = stepperService;
        this._isActive = false;
        this._isCompleted = false;
    }
    Object.defineProperty(UbiStepComponent.prototype, "isActive", {
        get: function () { return this._isActive; },
        set: function (state) { this._isActive = state; this.cdRef.detectChanges(); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UbiStepComponent.prototype, "isCompleted", {
        get: function () { return this._isCompleted; },
        set: function (state) {
            this._isCompleted = state;
            this.cdRef.detectChanges();
        },
        enumerable: true,
        configurable: true
    });
    UbiStepComponent.prototype.ngOnInit = function () {
    };
    UbiStepComponent.prototype.focus = function () {
        if (!this.isActive) {
            this.stepperService.setCurrentStep(this);
        }
    };
    UbiStepComponent.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: UbiStepperService }
    ]; };
    UbiStepComponent = __decorate([
        Component({
            selector: 'ubi-step',
            template: "<div class=\"ubi-step ubi-step__item\" [class.is-activated]=\"isActive\" [class.is-completed]=\"isCompleted\">\n  <a class=\"ubi-step__link\" href=\"javascript:void(0)\" (click)=\"focus()\">\n    <div class=\"ubi-step__icon\">\n      <ng-content select=\"[ubi-step-icon]\" #icon></ng-content>\n    </div>\n    <div class=\"ubi-step__title\">\n      <ng-content select=\"[ubi-step-title]\" #title></ng-content>\n    </div>\n  </a>\n</div>\n",
            changeDetection: ChangeDetectionStrategy.OnPush,
            styles: [":host /deep/ .ubi-step::after,:host /deep/ .ubi-step::before{content:'';position:absolute;z-index:0;top:40%;width:70%;height:4px}:host:first-child .ubi-step::before{display:none}:host:last-child .ubi-step::after{display:none}:host /deep/ .ubi-step{display:inline-block;position:relative;margin:0;width:175px;padding:40px 0 0;text-align:center}:host /deep/ .ubi-step::before{top:46%;left:-35%;background-color:#b3b3b3}:host /deep/ .ubi-step::after{z-index:1;top:46%;right:-31%}:host /deep/ .ubi-step.is-completed::before{background-image:-webkit-gradient(linear,right top,left top,from(#52c3cb),to(transparent));background-image:linear-gradient(to left,#52c3cb,transparent)}:host /deep/ .ubi-step.is-completed::after{background-image:-webkit-gradient(linear,left top,right top,from(#52c3cb),to(transparent));background-image:linear-gradient(to right,#52c3cb,transparent)}:host /deep/ .ubi-step.is-completed .ubi-step__icon{background-color:#52c3cb;box-shadow:0 0 0 5px transparent}:host /deep/ .ubi-step.is-completed .ubi-step__title{color:#52c3cb}:host /deep/ .ubi-step.is-activated::before,:host /deep/ .ubi-step:hover::before{background-image:-webkit-gradient(linear,right top,left top,from(#ffb15c),to(transparent));background-image:linear-gradient(to left,#ffb15c,transparent)}:host /deep/ .ubi-step.is-activated::after,:host /deep/ .ubi-step:hover::after{background-image:-webkit-gradient(linear,left top,right top,from(#ffb15c),to(transparent));background-image:linear-gradient(to right,#ffb15c,transparent)}:host /deep/ .ubi-step.is-activated .ubi-step__icon,:host /deep/ .ubi-step:hover .ubi-step__icon{background-color:#ffb15c;box-shadow:0 0 0 5px rgba(255,255,255,.2)}:host /deep/ .ubi-step.is-activated .ubi-step__title,:host /deep/ .ubi-step:hover .ubi-step__title{color:#ffb15c}:host /deep/ .ubi-step__link span{display:block}:host /deep/ .ubi-step__icon{display:-webkit-box;display:flex;-webkit-box-pack:center;justify-content:center;-webkit-box-align:center;align-items:center;position:absolute;z-index:2;top:0;left:calc(50% - 20px);margin:0 auto;width:40px;height:40px;border-radius:5px;background-color:#b3b3b3;-webkit-transform:rotate(45deg);transform:rotate(45deg)}:host /deep/ .ubi-step__icon img{-webkit-transform:rotate(-45deg);transform:rotate(-45deg)}:host /deep/ .ubi-step__icon .material-icons{color:#fff;-webkit-transform:rotate(-45deg);transform:rotate(-45deg)}:host /deep/ .ubi-step__title{position:absolute;right:0;left:0;margin:15px auto;max-width:110px;font-weight:400;font-size:12px;color:#546e7b;line-height:16px;text-transform:uppercase;text-decoration:none;letter-spacing:.2em}"]
        }),
        __metadata("design:paramtypes", [ChangeDetectorRef, UbiStepperService])
    ], UbiStepComponent);
    return UbiStepComponent;
}());

var UbiStepperComponent = /** @class */ (function () {
    function UbiStepperComponent(service, ref) {
        this.service = service;
        this.ref = ref;
        this.service.setInstance(this);
    }
    UbiStepperComponent.prototype.ngOnInit = function () {
    };
    UbiStepperComponent.prototype.ngAfterViewInit = function () {
    };
    UbiStepperComponent.ctorParameters = function () { return [
        { type: UbiStepperService },
        { type: ElementRef }
    ]; };
    __decorate([
        ContentChildren(UbiStepComponent),
        __metadata("design:type", QueryList)
    ], UbiStepperComponent.prototype, "steps", void 0);
    UbiStepperComponent = __decorate([
        Component({
            selector: 'ubi-stepper',
            template: "<div class=\"step-wrapper\">\n  <div class=\"steps\">\n    <ng-content></ng-content>\n  </div>\n</div>\n",
            styles: [".step-wrapper .steps{display:-webkit-box;display:flex;-webkit-box-pack:center;justify-content:center;-webkit-box-align:center;align-items:center;list-style:none}"]
        }),
        __metadata("design:paramtypes", [UbiStepperService, ElementRef])
    ], UbiStepperComponent);
    return UbiStepperComponent;
}());

var UbiStepperModule = /** @class */ (function () {
    function UbiStepperModule() {
    }
    UbiStepperModule_1 = UbiStepperModule;
    UbiStepperModule.forRoot = function () {
        return {
            ngModule: UbiStepperModule_1,
            providers: [UbiStepperService]
        };
    };
    var UbiStepperModule_1;
    UbiStepperModule = UbiStepperModule_1 = __decorate([
        NgModule({
            imports: [
                CommonModule
            ],
            exports: [UbiStepperComponent, UbiStepComponent],
            declarations: [UbiStepperComponent, UbiStepComponent]
        })
    ], UbiStepperModule);
    return UbiStepperModule;
}());

var UbiAuthFactory = /** @class */ (function () {
    function UbiAuthFactory(injector) {
        this.injector = injector;
    }
    /**
     * Create factory
     * @method create
     */
    UbiAuthFactory.prototype.create = function (provider) {
        return this.injector.get(provider);
    };
    UbiAuthFactory.ctorParameters = function () { return [
        { type: Injector }
    ]; };
    UbiAuthFactory = __decorate([
        Injectable(),
        __metadata("design:paramtypes", [Injector])
    ], UbiAuthFactory);
    return UbiAuthFactory;
}());

var UbiAuthDappMetaMaskService = /** @class */ (function () {
    function UbiAuthDappMetaMaskService() {
    }
    UbiAuthDappMetaMaskService.prototype.getWeb3 = function () {
    };
    UbiAuthDappMetaMaskService = __decorate([
        Injectable()
    ], UbiAuthDappMetaMaskService);
    return UbiAuthDappMetaMaskService;
}());
var UbiAuthDappPrivateKeyService = /** @class */ (function () {
    function UbiAuthDappPrivateKeyService() {
    }
    UbiAuthDappPrivateKeyService.prototype.getWeb3 = function () {
    };
    UbiAuthDappPrivateKeyService = __decorate([
        Injectable()
    ], UbiAuthDappPrivateKeyService);
    return UbiAuthDappPrivateKeyService;
}());

var UbiAuthTwoFAProvider = /** @class */ (function () {
    function UbiAuthTwoFAProvider() {
    }
    return UbiAuthTwoFAProvider;
}());
/**
 * This is just a placeholder that does nothing, in case you don't need a twoFA at all
 */
var UbiAuthFakeTwoFA = /** @class */ (function (_super) {
    __extends(UbiAuthFakeTwoFA, _super);
    function UbiAuthFakeTwoFA() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UbiAuthFakeTwoFA.prototype.twoFAConfirm = function () {
        return of({});
    };
    UbiAuthFakeTwoFA.prototype.twoFAResend = function () {
        return of({});
    };
    UbiAuthFakeTwoFA = __decorate([
        Injectable()
    ], UbiAuthFakeTwoFA);
    return UbiAuthFakeTwoFA;
}(UbiAuthTwoFAProvider));

var UbiAuthStateType;
(function (UbiAuthStateType) {
    UbiAuthStateType["signedIn"] = "signedIn";
    UbiAuthStateType["signedOut"] = "signedOut";
    UbiAuthStateType["mfaSetup"] = "mfaSetup";
    UbiAuthStateType["mfaRequired"] = "mfaRequired";
    UbiAuthStateType["setupOpt"] = "setupOpt";
    UbiAuthStateType["newPasswordRequired"] = "newPasswordRequired";
    UbiAuthStateType["enableMfaConfirmed"] = "enableMfaConfirmed";
    UbiAuthStateType["ninetyDaysBlocked"] = "ninetyDaysBlocked";
    UbiAuthStateType["ninetyDaysChangePasswordRequired"] = "ninetyDaysChangePasswordRequired";
    UbiAuthStateType["resetPasswordRequired"] = "resetPasswordRequired";
    UbiAuthStateType["emailConfirmRequired"] = "emailConfirmRequired";
})(UbiAuthStateType || (UbiAuthStateType = {}));

var UbiAuthIdentityProvider = /** @class */ (function () {
    function UbiAuthIdentityProvider() {
    }
    return UbiAuthIdentityProvider;
}());
/**
 * This is just a placeholder that does nothing, in case you don't need a twoFA at all
 */
var UbiAuthFakeIdentity = /** @class */ (function () {
    function UbiAuthFakeIdentity() {
    }
    UbiAuthFakeIdentity.prototype.getUser = function () {
        return of({});
    };
    UbiAuthFakeIdentity.prototype.getToken = function () {
        return of({});
    };
    UbiAuthFakeIdentity = __decorate([
        Injectable()
    ], UbiAuthFakeIdentity);
    return UbiAuthFakeIdentity;
}());

var UbiAuthCustomOAuthService = /** @class */ (function () {
    function UbiAuthCustomOAuthService(identityProvider) {
        this.identityProvider = identityProvider;
        this.authState$ = new Subject();
    }
    /**
     * Configuration for use Cognito Auth
     * @method configurations
     * @param config: Cognito config value
     */
    UbiAuthCustomOAuthService.prototype.configurations = function (config) {
        this._config = config;
    };
    /**
     * Login by cognito auth
     * @method login
     */
    UbiAuthCustomOAuthService.prototype.login = function () {
        var _this = this;
        var url = this._config.url;
        return from(this.getUser()).pipe(map(function (user) {
            _this.authState$.next({
                state: UbiAuthStateType.signedIn,
                user: user
            });
            return user;
        }), catchError(function (error) {
            window.location.assign(url);
            return error;
        }));
    };
    UbiAuthCustomOAuthService.prototype.getUser = function () {
        if (this.identityProvider instanceof UbiAuthFakeIdentity) {
            throw new Error('Please provide identify provider');
        }
        else {
            return from(this.identityProvider.getUser());
        }
    };
    UbiAuthCustomOAuthService.prototype.getToken = function () {
        if (this.identityProvider instanceof UbiAuthFakeIdentity) {
            throw new Error('Please provide identify provider');
        }
        else {
            return from(this.identityProvider.getToken());
        }
    };
    UbiAuthCustomOAuthService.ctorParameters = function () { return [
        { type: UbiAuthIdentityProvider }
    ]; };
    UbiAuthCustomOAuthService = __decorate([
        Injectable(),
        __metadata("design:paramtypes", [UbiAuthIdentityProvider])
    ], UbiAuthCustomOAuthService);
    return UbiAuthCustomOAuthService;
}());

var COGNITO_ERROR_CODE = {
    UserNotConfirmedException: 'UserNotConfirmedException',
    PasswordResetRequiredException: 'PasswordResetRequiredException',
    UserHasBLockedException: 'UserHasBLockedException'
};
var COGNITO_CHALLENGES = {
    EMAIL_CONFIRM_REQUIRED: 'EMAIL_CONFIRM_REQUIRED',
    PASSWORD_RESET_REQUIRED: 'PASSWORD_RESET_REQUIRED',
    CUSTOM_CHALLENGE: 'CUSTOM_CHALLENGE',
    NEW_PASSWORD_REQUIRED: 'NEW_PASSWORD_REQUIRED',
    SMS_MFA: 'SMS_MFA',
    SOFTWARE_TOKEN_MFA: 'SOFTWARE_TOKEN_MFA',
    MFA_SETUP: 'MFA_SETUP',
    NINETY_DAYS_BLOCKED: '90_DAYS_BLOCKED',
    NINETY_DAYS_CHANGE_PASSWORD: '90_DAYS_CHANGE_PASSWORD'
};

var UbiAuthISOCognitoUsernamePasswordService = /** @class */ (function () {
    function UbiAuthISOCognitoUsernamePasswordService(twoFAProvider) {
        this.twoFAProvider = twoFAProvider;
        this.authState$ = new Subject();
        this.resInfo = {};
    }
    /**
     * Configuration for based on the cognito rule
     */
    UbiAuthISOCognitoUsernamePasswordService.prototype.configurations = function (config) {
        this.userPool = new CognitoUserPool({
            endpoint: config.endpoint,
            ClientId: config.clientId,
            UserPoolId: config.userPoolId
        });
    };
    /**
     * Login
     * @method login
     */
    UbiAuthISOCognitoUsernamePasswordService.prototype.login = function (credentials) {
        var _this = this;
        var userData = {
            Username: credentials.username,
            Pool: this.userPool,
        };
        var cognitoUser = new CognitoUser(userData);
        var authenticationData = {
            Username: credentials.username,
            Password: credentials.password,
        };
        var authenticationDetails = new AuthenticationDetails(authenticationData);
        var that = this;
        return from(new Promise(function (resolve, reject) {
            var user = cognitoUser;
            cognitoUser.authenticateUser(authenticationDetails, {
                onSuccess: function (session) {
                    return resolve(session);
                },
                onFailure: function (err) {
                    if (err.code === COGNITO_ERROR_CODE.UserNotConfirmedException) { // User not confirmed email
                        return resolve({
                            user: user,
                            challengeName: COGNITO_CHALLENGES.EMAIL_CONFIRM_REQUIRED,
                            challengeParam: null
                        });
                    }
                    else if (err.code === COGNITO_ERROR_CODE.PasswordResetRequiredException) { // Must to change the password
                        return resolve({
                            user: user,
                            challengeName: COGNITO_CHALLENGES.PASSWORD_RESET_REQUIRED,
                            challengeParam: null
                        });
                    }
                    // Can't authenticated user
                    return reject(err);
                },
                // Custom challenge authentication
                customChallenge: function (challengeParam) {
                    return resolve({
                        user: user,
                        username: credentials.username,
                        challengeName: COGNITO_CHALLENGES.CUSTOM_CHALLENGE,
                        challengeParam: challengeParam
                    });
                },
                // Software token MFA required
                totpRequired: function (challengeName, challengeParam) {
                    that.authenticationDetailsTemp = authenticationData;
                    return resolve({
                        user: user,
                        username: credentials.username,
                        challengeName: challengeName,
                        challengeParam: challengeParam
                    });
                },
                // SMS MFA required
                mfaRequired: function (challengeName, challengeParam) {
                    return resolve({
                        user: user,
                        challengeName: challengeName,
                        challengeParam: challengeParam
                    });
                },
                // Must to setup MFA
                mfaSetup: function (challengeName, challengeParam) {
                    return resolve({
                        user: user,
                        challengeName: challengeName,
                        challengeParam: challengeParam
                    });
                },
                // First time login with temp password
                newPasswordRequired: function (userAttributes, requiredAttributes) {
                    return resolve({
                        user: user,
                        challengeName: COGNITO_CHALLENGES.NEW_PASSWORD_REQUIRED,
                        challengeParam: {
                            userAttributes: userAttributes,
                            requiredAttributes: requiredAttributes,
                        }
                    });
                },
                // Select MFA option
                selectMFAType: function (challengeName, challengeParam) {
                    return resolve({
                        user: user,
                        challengeName: challengeName,
                        challengeParam: challengeParam
                    });
                },
            });
        })).pipe(map(function (res) {
            if (res.challengeName === COGNITO_CHALLENGES.SMS_MFA || res.challengeName === COGNITO_CHALLENGES.SOFTWARE_TOKEN_MFA) { // MFA required
                _this.authState$.next({
                    state: UbiAuthStateType.mfaRequired,
                    user: res.user
                });
                return {
                    challenge: UbiAuthStateType.mfaRequired,
                    user: res.user
                };
            }
            else if (res.challengeName === COGNITO_CHALLENGES.NEW_PASSWORD_REQUIRED) { // Change password required
                _this.authState$.next({
                    state: UbiAuthStateType.newPasswordRequired,
                    user: res.user
                });
                return {
                    challenge: UbiAuthStateType.newPasswordRequired,
                    user: res.user
                };
            }
            else if (res.challengeName === COGNITO_CHALLENGES.MFA_SETUP) { // MFA setup required
                _this.authState$.next({
                    state: UbiAuthStateType.mfaSetup,
                    user: res.user
                });
                return {
                    challenge: UbiAuthStateType.mfaSetup,
                    user: res.user
                };
            }
            else if (res.challengeName === COGNITO_CHALLENGES.CUSTOM_CHALLENGE && res.challengeParam) {
                if (res.challengeParam.type === COGNITO_CHALLENGES.NINETY_DAYS_BLOCKED) { // 90 days inactivity blocked
                    _this.authState$.next({
                        state: UbiAuthStateType.ninetyDaysBlocked,
                        user: res.user
                    });
                    return {
                        challenge: UbiAuthStateType.ninetyDaysBlocked,
                        user: res.user
                    };
                }
                else if (res.challengeParam.type === COGNITO_CHALLENGES.NINETY_DAYS_CHANGE_PASSWORD) { // 90 days change password
                    _this.authState$.next({
                        state: UbiAuthStateType.ninetyDaysChangePasswordRequired,
                        user: res.user
                    });
                    return {
                        challenge: UbiAuthStateType.ninetyDaysChangePasswordRequired,
                        user: res.user
                    };
                }
            }
            else if (res.challengeName === COGNITO_CHALLENGES.EMAIL_CONFIRM_REQUIRED) { // Confirm email required
                _this.authState$.next({
                    state: UbiAuthStateType.emailConfirmRequired,
                    user: res.user
                });
                return {
                    challenge: UbiAuthStateType.emailConfirmRequired,
                    user: res.user
                };
            }
            else if (res.challengeName === COGNITO_CHALLENGES.PASSWORD_RESET_REQUIRED) { // Reset password required
                _this.authState$.next({
                    state: UbiAuthStateType.resetPasswordRequired,
                    user: res.user
                });
                return {
                    challenge: UbiAuthStateType.resetPasswordRequired,
                    user: res.user
                };
            }
            else { // User successfully authenticated
                var idToken = res.idToken;
                _this.resInfo = {
                    token: idToken.jwtToken,
                    user: idToken.payload,
                    cognitoUser: res.user,
                    accessToken: res.accessToken.jwtToken
                };
                _this.resInfo.token = idToken.jwtToken;
                _this.resInfo.user = idToken.payload;
                _this.resInfo.cognitoUser = res.user;
                _this.resInfo.accessToken = res.accessToken.jwtToken;
                _this.authState$.next({
                    state: UbiAuthStateType.signedIn,
                    user: _this.resInfo.user
                });
                return _this.resInfo;
            }
        }));
    };
    /**
     * Logout
     * @method logout
     */
    UbiAuthISOCognitoUsernamePasswordService.prototype.logout = function () {
        var _this = this;
        return from(new Promise(function (resolve, reject) {
            var currentUser = _this.userPool.getCurrentUser();
            if (currentUser) {
                currentUser.getSession(function (error) {
                    if (error) {
                        return reject(error);
                    }
                    currentUser.globalSignOut({
                        onFailure: function (err) {
                            currentUser.signOut();
                            return reject(err);
                        },
                        onSuccess: function (message) {
                            return resolve(message);
                        }
                    });
                });
            }
            else {
                reject({ message: 'User has not been authenticated' });
            }
        }));
    };
    /**
     * Signup
     * @method signup
     */
    UbiAuthISOCognitoUsernamePasswordService.prototype.signup = function (credentials) {
        var _this = this;
        var mapAttributes = [];
        if (credentials.attributes) {
            mapAttributes = credentials.attributes.map(function (attribute) {
                return new CognitoUserAttribute({
                    Name: attribute.name || attribute.Name,
                    Value: attribute.value || attribute.Value
                });
            });
        }
        return from(new Promise(function (resolve, reject) {
            return _this.userPool.signUp(credentials.username, credentials.password, mapAttributes, null, function (err, result) {
                if (err) {
                    return reject(err);
                }
                return resolve(result);
            });
        }));
    };
    /**
     * Confirm Signup
     * @method confirmSignUp
     */
    UbiAuthISOCognitoUsernamePasswordService.prototype.confirmSignUp = function (username, code) {
        var _this = this;
        return from(new Promise(function (resolve, reject) {
            var userData = {
                Username: username,
                Pool: _this.userPool,
            };
            var cognitoUser = new CognitoUser(userData);
            cognitoUser.confirmRegistration(code, true, function (err, result) {
                if (err) {
                    return reject(err);
                }
                return resolve(result);
            });
        }));
    };
    /**
     * Resend code
     * @method resendConfirmCode
     */
    UbiAuthISOCognitoUsernamePasswordService.prototype.resendConfirmCode = function (username) {
        var _this = this;
        return from(new Promise(function (resolve, reject) {
            var userData = {
                Username: username,
                Pool: _this.userPool,
            };
            var cognitoUser = new CognitoUser(userData);
            cognitoUser.resendConfirmationCode(function (err, result) {
                if (err) {
                    return reject(err);
                }
                return resolve(result);
            });
        }));
    };
    UbiAuthISOCognitoUsernamePasswordService.prototype.attributesToObject = function (attributes) {
        var obj = {};
        if (attributes) {
            attributes.map(function (attribute) {
                if (attribute.Value === 'true') {
                    obj[attribute.Name] = true;
                }
                else if (attribute.Value === 'false') {
                    obj[attribute.Name] = false;
                }
                else {
                    obj[attribute.Name] = attribute.Value;
                }
            });
        }
        return obj;
    };
    /**
     * Get current user
     * @method getUser
     */
    UbiAuthISOCognitoUsernamePasswordService.prototype.getUser = function (bypassCache) {
        var _this = this;
        if (bypassCache === void 0) { bypassCache = false; }
        var that = this;
        return from(new Promise(function (resolve, reject) {
            var currentUser = _this.userPool.getCurrentUser();
            if (currentUser) {
                currentUser.getSession(function (error) {
                    if (error) {
                        return reject(error);
                    }
                    currentUser.getUserData(function (err, result) {
                        if (err) {
                            return reject(err);
                        }
                        var preferredMFA = result.PreferredMfaSetting || 'NOMFA';
                        var attributeList = [];
                        for (var i = 0; i < result.UserAttributes.length; i++) {
                            var attribute = {
                                Name: result.UserAttributes[i].Name,
                                Value: result.UserAttributes[i].Value,
                            };
                            var userAttribute = new CognitoUserAttribute(attribute);
                            attributeList.push(userAttribute);
                        }
                        var attributes = that.attributesToObject(attributeList);
                        Object.assign(currentUser, { attributes: attributes, preferredMFA: preferredMFA });
                        return resolve(currentUser);
                    }, { bypassCache: bypassCache });
                });
            }
            else {
                return reject({ message: 'User has not been authenticated' });
            }
        }));
    };
    /**
     * Forgot Password
     * @method forgotPassword
     */
    UbiAuthISOCognitoUsernamePasswordService.prototype.forgotPassword = function (username) {
        var _this = this;
        return from(new Promise(function (resolve, reject) {
            var userData = {
                Username: username,
                Pool: _this.userPool,
            };
            var cognitoUser = new CognitoUser(userData);
            cognitoUser.forgotPassword({
                onFailure: function (err) {
                    return reject(err);
                },
                onSuccess: function (data) {
                    return resolve(data);
                },
                inputVerificationCode: function (data) {
                    return resolve(data);
                }
            });
        }));
    };
    /**
     * Confirm Forgot Password
     * @method confirmForgotPassword
     */
    UbiAuthISOCognitoUsernamePasswordService.prototype.confirmForgotPassword = function (username, code, password) {
        var _this = this;
        return from(new Promise(function (resolve, reject) {
            var userData = {
                Username: username,
                Pool: _this.userPool,
            };
            var cognitoUser = new CognitoUser(userData);
            cognitoUser.confirmPassword(code, password, {
                onFailure: function (err) {
                    return reject(err);
                },
                onSuccess: function () {
                    return resolve({ message: 'Password confirmed successfully' });
                }
            });
        }));
    };
    /**
     * Change Password
     * @method changePassword
     */
    UbiAuthISOCognitoUsernamePasswordService.prototype.changePassword = function (user, oldPassword, newPassword) {
        var _this = this;
        return from(new Promise(function (resolve, reject) {
            var currentUser = _this.userPool.getCurrentUser();
            if (currentUser) {
                currentUser.getSession(function (error) {
                    if (error) {
                        return reject(error);
                    }
                    currentUser.changePassword(oldPassword, newPassword, function (err, success) {
                        if (err) {
                            return reject(err);
                        }
                        return resolve(success);
                    });
                });
            }
            else {
                return reject({ message: 'User has not been authenticated' });
            }
        }));
    };
    /**
     * Enable Multiple Factor Authentication
     * @method enableMfa
     */
    UbiAuthISOCognitoUsernamePasswordService.prototype.enableMfa = function () {
        var _this = this;
        return from(new Promise(function (resolve, reject) {
            var currentUser = _this.userPool.getCurrentUser();
            if (currentUser) {
                currentUser.getSession(function (error) {
                    if (error) {
                        return reject(error);
                    }
                    currentUser.associateSoftwareToken({
                        onFailure: function (err) {
                            return reject(err);
                        },
                        associateSecretCode: function (code) {
                            return resolve(code);
                        }
                    });
                });
            }
            else {
                return reject({ message: 'User has not been authenticated' });
            }
        }));
    };
    /**
     * Confirm enable Multiple Factor Authentication
     * @method enableMfaConfirm
     */
    UbiAuthISOCognitoUsernamePasswordService.prototype.enableMfaConfirm = function (user, answer) {
        var _this = this;
        return from(new Promise(function (resolve, reject) {
            var currentUser = _this.userPool.getCurrentUser();
            if (currentUser) {
                currentUser.getSession(function (error) {
                    if (error) {
                        return reject(error);
                    }
                    currentUser.verifySoftwareToken(answer, null, {
                        onFailure: function (err) {
                            return reject(err);
                        },
                        onSuccess: function (session) {
                            var totpMfaSettings = {
                                PreferredMfa: true,
                                Enabled: true,
                            };
                            currentUser.setUserMfaPreference(null, totpMfaSettings, function (err) {
                                if (err) {
                                    return reject(err);
                                }
                                return resolve(session);
                            });
                        }
                    });
                });
            }
            else {
                return reject({ message: 'User has not been authenticated' });
            }
        }));
    };
    /**
     *  Disable MFA
     * @method disableMfa
     */
    UbiAuthISOCognitoUsernamePasswordService.prototype.disableMfa = function () {
        var _this = this;
        return from(new Promise(function (resolve, reject) {
            var currentUser = _this.userPool.getCurrentUser();
            if (currentUser) {
                currentUser.getSession(function (error) {
                    if (error) {
                        return reject(error);
                    }
                    var totpMfaSettings = {
                        PreferredMfa: false,
                        Enabled: false,
                    };
                    currentUser.setUserMfaPreference(null, totpMfaSettings, function (err, success) {
                        if (err) {
                            return reject(err);
                        }
                        return resolve(success);
                    });
                });
            }
            else {
                return reject({ message: 'User has not been authenticated' });
            }
        }));
    };
    /**
     *  Verify MFA when login
     * @method twoFAConfirm
     */
    UbiAuthISOCognitoUsernamePasswordService.prototype.twoFAConfirm = function (identifier, code, mfaType) {
        var that = this;
        var authenticationData = this.authenticationDetailsTemp;
        var userData = {
            Username: authenticationData.Username,
            Pool: this.userPool,
        };
        var cognitoUser = new CognitoUser(userData);
        var authenticationDetails = new AuthenticationDetails(authenticationData);
        return from(new Promise(function (resolve, reject) {
            if (!authenticationData) {
                return reject({ message: 'Not login yet' });
            }
            cognitoUser.authenticateUser(authenticationDetails, {
                onSuccess: function () {
                    return resolve('SUCCESS');
                },
                onFailure: function (err) {
                    return reject(err);
                },
                totpRequired: function () {
                    cognitoUser.sendMFACode(code, {
                        onFailure: function (err) {
                            if (err.code === COGNITO_ERROR_CODE.UserHasBLockedException) {
                                return resolve({
                                    challenge: UbiAuthStateType.ninetyDaysBlocked,
                                    user: cognitoUser,
                                    message: err.message
                                });
                            }
                            else if (err.code === COGNITO_ERROR_CODE.PasswordResetRequiredException) {
                                return resolve({
                                    challenge: UbiAuthStateType.ninetyDaysChangePasswordRequired,
                                    user: cognitoUser,
                                    message: err.message
                                });
                            }
                            return reject(err);
                        },
                        onSuccess: function (session) {
                            if (!that.resInfo) {
                                that.resInfo = {};
                            }
                            var idToken = session.getIdToken();
                            that.resInfo.token = idToken.getJwtToken();
                            that.resInfo.user = idToken.payload;
                            that.resInfo.accessToken = session.getAccessToken().getJwtToken();
                            that.authState$.next({
                                state: UbiAuthStateType.signedIn,
                                user: that.resInfo.user,
                            });
                            return resolve(that.resInfo);
                        }
                    }, mfaType);
                }
            });
        }));
    };
    /**
     * Confirm n inty days change password
     * @method confirmNinetyDaysChangePassword
     */
    UbiAuthISOCognitoUsernamePasswordService.prototype.confirmNinetyDaysChangePassword = function (user) {
        var userData = {
            Username: user.username,
            Pool: this.userPool,
        };
        var cognitoUser = new CognitoUser(userData);
        return from(new Promise(function (resolve, reject) {
            cognitoUser.sendCustomChallengeAnswer({
                type: COGNITO_CHALLENGES.NINETY_DAYS_CHANGE_PASSWORD
            }, {
                onFailure: function (reason) {
                    if (reason.code === COGNITO_ERROR_CODE.PasswordResetRequiredException) {
                        return resolve({
                            message: reason.message,
                            challengeName: COGNITO_CHALLENGES.PASSWORD_RESET_REQUIRED,
                            challengeParam: null
                        });
                    }
                    return reject(reason);
                },
                onSuccess: function (session) {
                    return resolve(session);
                }
            });
        }));
    };
    /**
     * Resend 2FA to retrieve the verification code
     * @method twoFAResend
     * @param identifier can be username, email or phone_number etc...
     */
    UbiAuthISOCognitoUsernamePasswordService.prototype.twoFAResend = function (identifier) {
        var _this = this;
        if (this.twoFAProvider instanceof UbiAuthFakeTwoFA) {
            return from(new Promise(function (resolve, reject) {
                var userData = {
                    Username: identifier.Username,
                    Pool: _this.userPool,
                };
                var cognitoUser = new CognitoUser(userData);
                cognitoUser.resendConfirmationCode(function (err, success) {
                    if (err) {
                        reject(err);
                    }
                    else {
                        resolve(success);
                    }
                });
            }));
        }
        return this.twoFAProvider.twoFAResend(identifier);
    };
    /**
     * Confirm new password
     * @method completeNewPassword
     */
    UbiAuthISOCognitoUsernamePasswordService.prototype.completeNewPassword = function (user, newPassword) {
        var that = this;
        return from(new Promise(function (resolve, reject) {
            if (!newPassword) {
                return reject({ message: 'Empty Password' });
            }
            user.completeNewPasswordChallenge(newPassword, null, {
                onSuccess: function (session) {
                    var idToken = session.getIdToken();
                    that.resInfo.token = idToken.getJwtToken();
                    that.resInfo.user = idToken.payload;
                    that.resInfo.accessToken = session.getAccessToken().getJwtToken();
                    that.authState$.next({
                        state: UbiAuthStateType.signedIn,
                        user: that.resInfo.user,
                    });
                    return resolve(that.resInfo);
                },
                onFailure: function (err) {
                    return reject(err);
                },
                mfaRequired: function () {
                    return resolve({
                        challenge: UbiAuthStateType.mfaRequired,
                        user: user
                    });
                },
                mfaSetup: function () {
                    return resolve({
                        challenge: UbiAuthStateType.mfaSetup,
                        user: user
                    });
                },
                customChallenge: function (challengeParam) {
                    if (challengeParam.type === COGNITO_CHALLENGES.NINETY_DAYS_BLOCKED) {
                        return resolve({
                            challenge: UbiAuthStateType.ninetyDaysBlocked,
                            user: user
                        });
                    }
                    else if (challengeParam.type === COGNITO_CHALLENGES.NINETY_DAYS_CHANGE_PASSWORD) {
                        return resolve({
                            challenge: UbiAuthStateType.ninetyDaysChangePasswordRequired,
                            user: user
                        });
                    }
                    return resolve(challengeParam);
                }
            });
        }));
    };
    /**
     * Update attributes
     * @method updateAttributes
     */
    UbiAuthISOCognitoUsernamePasswordService.prototype.updateAttributes = function (user, attributes) {
        var attributeList = [];
        var that = this;
        return from(new Promise(function (resolve, reject) {
            that.getSession().toPromise().then(function (session) {
                for (var key in attributes) {
                    if (key !== 'sub' && key.indexOf('_verified') < 0) {
                        var attr = {
                            Name: key,
                            Value: attributes[key],
                        };
                        attributeList.push(attr);
                    }
                }
                user.updateAttributes(attributeList, function (err, result) {
                    if (err) {
                        return reject(err);
                    }
                    else {
                        return resolve(result);
                    }
                });
            });
        }));
    };
    /**
     * Get current Session
     * @method getSession
     */
    UbiAuthISOCognitoUsernamePasswordService.prototype.getSession = function () {
        var currentUser = this.userPool.getCurrentUser();
        return from(new Promise(function (resolve, reject) {
            currentUser.getSession(function (err, session) {
                if (err) {
                    return reject(err);
                }
                else {
                    return resolve(session);
                }
            });
        }));
    };
    /**
     * Get current token
     * @method getToken
     */
    UbiAuthISOCognitoUsernamePasswordService.prototype.getToken = function () {
        return this.getSession().pipe(map(function (user) {
            return user.getIdToken().getJwtToken();
        }));
    };
    /**
     * Get current auth state
     * @method authState
     */
    UbiAuthISOCognitoUsernamePasswordService.prototype.authState = function () {
        return this.authState$.asObservable();
    };
    UbiAuthISOCognitoUsernamePasswordService.ctorParameters = function () { return [
        { type: UbiAuthTwoFAProvider }
    ]; };
    UbiAuthISOCognitoUsernamePasswordService = __decorate([
        Injectable(),
        __metadata("design:paramtypes", [UbiAuthTwoFAProvider])
    ], UbiAuthISOCognitoUsernamePasswordService);
    return UbiAuthISOCognitoUsernamePasswordService;
}());

var UbiAuthModule = /** @class */ (function () {
    // https://angular.io/guide/singleton-services#prevent-reimport-of-the-coremodule
    function UbiAuthModule(parentModule) {
        if (parentModule) {
            throw new Error('UbiAuthModule is already loaded. Import it in the AppModule only');
        }
    }
    UbiAuthModule_1 = UbiAuthModule;
    UbiAuthModule.forRoot = function (config) {
        if (config === void 0) { config = {}; }
        return {
            ngModule: UbiAuthModule_1,
            providers: [
                config.twoFA || { provide: UbiAuthTwoFAProvider, useClass: UbiAuthFakeTwoFA },
                config.identifyProvider || { provide: UbiAuthIdentityProvider, useClass: UbiAuthFakeIdentity },
                // AmplifyService,
                UbiAuthFactory,
                // UbiAuthCognitoHostedService,
                // UbiAuthCognitoUsernamePasswordService,
                UbiAuthISOCognitoUsernamePasswordService,
                UbiAuthDappMetaMaskService,
                UbiAuthDappPrivateKeyService,
                UbiAuthCustomOAuthService,
            ]
        };
    };
    var UbiAuthModule_1;
    UbiAuthModule.ctorParameters = function () { return [
        { type: UbiAuthModule, decorators: [{ type: Optional }, { type: SkipSelf }] }
    ]; };
    UbiAuthModule = UbiAuthModule_1 = __decorate([
        NgModule({
            imports: [],
            declarations: []
        }),
        __param(0, Optional()), __param(0, SkipSelf()),
        __metadata("design:paramtypes", [UbiAuthModule])
    ], UbiAuthModule);
    return UbiAuthModule;
}());

var FingerPrintService = /** @class */ (function () {
    function FingerPrintService(ngZone) {
        this.ngZone = ngZone;
        this.isMobile = this.isMobileDevice();
    }
    FingerPrintService.prototype.isMobileDevice = function () {
        return includes(navigator.userAgent, 'Mobi');
    };
    FingerPrintService.prototype.save = function (key, password) {
        var _this = this;
        var saveKey = new Promise(function (resolve, reject) {
            _this.ngZone.run(function () {
                window.plugins.touchid.isAvailable(function () {
                    window.plugins.touchid.save(key, password, function () {
                        resolve(true);
                    }, function (err) {
                        reject(err);
                    });
                }, function () {
                    reject({ message: 'Biometric is not available!' });
                });
            });
        });
        return from(saveKey);
    };
    FingerPrintService.prototype.verify = function (key, message) {
        var _this = this;
        var verifyKey = new Promise(function (resolve, reject) {
            _this.ngZone.run(function () {
                window.plugins.touchid.isAvailable(function () {
                    window.plugins.touchid.verify(key, message, function (password) {
                        resolve(password);
                    }, function (err) {
                        reject(err);
                    });
                }, function () {
                    reject({ message: 'Biometric is not available!' });
                });
            });
        });
        return from(verifyKey);
    };
    FingerPrintService.prototype.hasKey = function (key) {
        var _this = this;
        var hasKey = new Promise(function (resolve, reject) {
            _this.ngZone.run(function () {
                window.plugins.touchid.isAvailable(function () {
                    window.plugins.touchid.has(key, function () {
                        resolve(true);
                    }, function (err) {
                        reject(err);
                    });
                }, function () {
                    reject({ message: 'Biometric is not available!' });
                });
            });
        });
        return from(hasKey);
    };
    FingerPrintService.ctorParameters = function () { return [
        { type: NgZone }
    ]; };
    FingerPrintService.ngInjectableDef = ɵɵdefineInjectable({ factory: function FingerPrintService_Factory() { return new FingerPrintService(ɵɵinject(NgZone)); }, token: FingerPrintService, providedIn: "root" });
    FingerPrintService = __decorate([
        Injectable({
            providedIn: 'root'
        }),
        __metadata("design:paramtypes", [NgZone])
    ], FingerPrintService);
    return FingerPrintService;
}());

var LocalStorageService = /** @class */ (function () {
    function LocalStorageService() {
    }
    LocalStorageService.prototype.getItem = function (key) {
        return JSON.parse(localStorage.getItem(key) || null);
    };
    LocalStorageService.prototype.setItem = function (key, value) {
        localStorage.setItem(key, JSON.stringify(value));
    };
    LocalStorageService.prototype.removeItem = function (key) {
        localStorage.removeItem(key);
    };
    LocalStorageService = __decorate([
        Injectable(),
        __metadata("design:paramtypes", [])
    ], LocalStorageService);
    return LocalStorageService;
}());

var UbiDialogComponent = /** @class */ (function () {
    function UbiDialogComponent(dialog) {
        this.dialog = dialog;
        this.close$ = new EventEmitter();
        this.configurations = {};
    }
    UbiDialogComponent.prototype.ngOnInit = function () {
    };
    UbiDialogComponent.prototype.subscribeToCloseEvent = function () {
        var _this = this;
        this.dialogRef.afterClosed().pipe(take(1)).subscribe(function (data) {
            _this.close$.emit(data);
        });
    };
    UbiDialogComponent.prototype.close = function () {
        this.dialogRef.close('close');
    };
    UbiDialogComponent.prototype.onResponse = function () {
        return this.close$.asObservable();
    };
    UbiDialogComponent.prototype.show = function (componentRef, matConfig) {
        var config = new MatDialogConfig();
        config.panelClass = this.configurations.panelClass;
        config.autoFocus = true;
        if (matConfig) {
            config = Object.assign(config, matConfig);
        }
        if (componentRef) {
            this.dialogRef = this.dialog.open(componentRef, config);
        }
        else {
            this.dialogRef = this.dialog.open(this.dialogTemplate, config);
        }
        this.subscribeToCloseEvent();
    };
    UbiDialogComponent.prototype.submit = function (data) {
        this.dialogRef.close(data || 'submit');
    };
    UbiDialogComponent.ctorParameters = function () { return [
        { type: MatDialog }
    ]; };
    __decorate([
        ViewChild('dialogTemplate', { static: false }),
        __metadata("design:type", TemplateRef)
    ], UbiDialogComponent.prototype, "dialogTemplate", void 0);
    UbiDialogComponent = __decorate([
        Component({
            selector: 'ubi-dialog',
            template: "<ng-template #dialogTemplate>\n  <h1 #customHeaderContent mat-dialog-title>\n    <ng-content select=\"[ubi-dialog-header]\"></ng-content>\n  </h1>\n  <ng-template *ngIf=\"customHeaderContent.childNodes.length == 0 then headerDefaultTemplate\"></ng-template>\n  <div mat-dialog-content #content>\n    <ng-content select=\"[ubi-dialog-content]\"></ng-content>\n  </div>\n  <ng-template *ngIf=\"content.childNodes.length == 0 then contentDefaultTemplate\"></ng-template>\n\n  <div #customActionContent mat-dialog-actions>\n    <ng-content #content select=\"[ubi-dialog-action]\"></ng-content>\n  </div>\n  <ng-template *ngIf=\"configurations.type === 'confirm' && customActionContent.childNodes.length == 0 then confirmActionTemplate\"></ng-template>\n  <ng-template *ngIf=\"configurations.type === 'alert' && customActionContent.childNodes.length == 0 then alertActionTemplate\"></ng-template>\n  <ng-template #alertActionTemplate>\n    <div mat-dialog-actions>\n      <button  class=\"mat-stroked-button btn-large\" color=\"primary\" (click)=\"close()\">{{configurations.okTitle}}</button>\n    </div>\n  </ng-template>\n\n  <ng-template #confirmActionTemplate>\n    <div mat-dialog-actions>\n      <button class=\"mat-button btn-gradient\" color=\"primary\" (click)=\"submit()\">{{configurations.submitTitle}}</button>\n      <button class=\"mat-stroked-button\" color=\"secondary\" (click)=\"close()\">{{configurations.cancelTitle}}</button>\n    </div>\n  </ng-template>\n\n  <ng-template #headerDefaultTemplate>\n    <h1 mat-dialog-title>\n      {{configurations.title}}\n    </h1>\n  </ng-template>\n\n  <ng-template #contentDefaultTemplate>\n    <div mat-dialog-content>\n      {{configurations.content}}\n    </div>\n  </ng-template>\n</ng-template>\n",
            styles: [""]
        }),
        __metadata("design:paramtypes", [MatDialog])
    ], UbiDialogComponent);
    return UbiDialogComponent;
}());

var UbiDialogModule = /** @class */ (function () {
    function UbiDialogModule() {
    }
    UbiDialogModule = __decorate([
        NgModule({
            imports: [
                CommonModule,
                MatDialogModule
            ],
            exports: [
                UbiDialogComponent
            ],
            declarations: [
                UbiDialogComponent
            ],
            entryComponents: [UbiDialogComponent]
        })
    ], UbiDialogModule);
    return UbiDialogModule;
}());

var UbiDialogService = /** @class */ (function () {
    function UbiDialogService(dialog, componentFactoryResolver, injector) {
        this.dialog = dialog;
        this.componentFactoryResolver = componentFactoryResolver;
        this.injector = injector;
        this.configurations = {};
        this.configurations.type = this.configurations.type || 'alert';
        this.configurations.okTitle = this.configurations.okTitle || 'OK';
        this.configurations.cancelTitle = this.configurations.cancelTitle || 'CANCEL';
        this.configurations.submitTitle = this.configurations.submitTitle || 'OK';
        this.configurations.panelClass = this.configurations.panelClass || 'small';
    }
    UbiDialogService.prototype.getComponent = function () {
        var componentFactory = this.componentFactoryResolver.resolveComponentFactory(UbiDialogComponent);
        var ref = componentFactory.create(this.injector);
        this.dialogRef = ref.instance;
        this.dialogRef.configurations = this.configurations;
        return ref;
    };
    UbiDialogService.prototype.alert = function (message, title, config) {
        this.configurations.content = message;
        this.configurations.title = title;
        this.configurations.type = 'alert';
        var ref = this.getComponent();
        ref.instance.configurations = this.configurations;
        this.dialog.open(ref.instance.dialogTemplate, config);
    };
    UbiDialogService.prototype.confirm = function (message, title, config) {
        this.configurations.content = message;
        this.configurations.title = title;
        this.configurations.type = 'confirm';
        var ref = this.getComponent();
        ref.instance.configurations = this.configurations;
        this.dialog.open(ref.instance.dialogTemplate, config);
    };
    UbiDialogService.prototype.hide = function () {
        this.dialogRef.close();
    };
    UbiDialogService.prototype.submit = function () {
        this.dialogRef.submit();
    };
    UbiDialogService.prototype.show = function (matConfig) {
        var config = new MatDialogConfig();
        config.panelClass = this.configurations.panelClass;
        config.autoFocus = true;
        config = Object.assign(config, matConfig);
        var ref = this.getComponent();
        ref.instance.configurations = this.configurations;
        this.dialog.open(ref.instance.dialogTemplate, config);
    };
    UbiDialogService.ctorParameters = function () { return [
        { type: MatDialog },
        { type: ComponentFactoryResolver },
        { type: Injector }
    ]; };
    UbiDialogService.ngInjectableDef = ɵɵdefineInjectable({ factory: function UbiDialogService_Factory() { return new UbiDialogService(ɵɵinject(MatDialog$1), ɵɵinject(ComponentFactoryResolver), ɵɵinject(INJECTOR)); }, token: UbiDialogService, providedIn: "root" });
    UbiDialogService = __decorate([
        Injectable({
            providedIn: 'root'
        }),
        __metadata("design:paramtypes", [MatDialog,
            ComponentFactoryResolver,
            Injector])
    ], UbiDialogService);
    return UbiDialogService;
}());

var UbiAppshellComponent = /** @class */ (function () {
    function UbiAppshellComponent() {
    }
    UbiAppshellComponent = __decorate([
        Component({
            selector: 'ubi-appshell',
            template: "<ng-content select=\"[ubi-nav]\"></ng-content>\n<ng-content select=\"[ubi-content]\"></ng-content>\n",
            styles: [""]
        })
    ], UbiAppshellComponent);
    return UbiAppshellComponent;
}());

var UbiNavComponent = /** @class */ (function () {
    function UbiNavComponent() {
    }
    UbiNavComponent.prototype.ngOnInit = function () {
    };
    UbiNavComponent = __decorate([
        Component({
            selector: 'ubi-nav',
            template: "<ng-content></ng-content>\n",
            styles: [":host /deep/ .ubi-menu-item{padding:0 15px;font-weight:300;font-size:.9rem;text-decoration:none;letter-spacing:.05em}:host /deep/ .ubi-menu-item:first-child{padding-left:0}:host /deep/ .ubi-menu-item:last-child{padding-right:0}"]
        }),
        __metadata("design:paramtypes", [])
    ], UbiNavComponent);
    return UbiNavComponent;
}());

var UbiContentComponent = /** @class */ (function () {
    function UbiContentComponent() {
    }
    UbiContentComponent.prototype.ngOnInit = function () {
    };
    UbiContentComponent = __decorate([
        Component({
            selector: 'ubi-content',
            template: "<ng-content></ng-content>\n",
            styles: [""]
        }),
        __metadata("design:paramtypes", [])
    ], UbiContentComponent);
    return UbiContentComponent;
}());

var UbiMenuDirective = /** @class */ (function () {
    // @HostBinding('class') elementClass = 'ubi-menu-item';
    function UbiMenuDirective(renderer, hostElement) {
        this.renderer = renderer;
        renderer.addClass(hostElement.nativeElement, 'ubi-menu-item');
    }
    UbiMenuDirective.ctorParameters = function () { return [
        { type: Renderer2 },
        { type: ElementRef }
    ]; };
    UbiMenuDirective = __decorate([
        Directive({
            // tslint:disable-next-line:directive-selector
            selector: '[ubi-menu-item]'
        }),
        __metadata("design:paramtypes", [Renderer2, ElementRef])
    ], UbiMenuDirective);
    return UbiMenuDirective;
}());

var UbiAppshellService = /** @class */ (function () {
    function UbiAppshellService() {
        this.onThemeChange$ = new EventEmitter();
    }
    /**
     * Apply theme to current application
     * Noted: The theme will be stored at LocalStorage under key `ubi-theme`
     * @param theme Theme object
     */
    UbiAppshellService.prototype.setTheme = function (theme, themeName) {
        var e_1, _a;
        if (themeName === void 0) { themeName = 'ubi-theme'; }
        var themeJson = JSON.parse(localStorage.getItem('ubi-themes')) || {};
        themeJson[themeName] = theme;
        localStorage.setItem('ubi-themes', JSON.stringify(themeJson));
        this.onThemeChange$.emit(theme);
        var themeWrapper = document.querySelector('html');
        try {
            for (var theme_1 = __values(theme), theme_1_1 = theme_1.next(); !theme_1_1.done; theme_1_1 = theme_1.next()) {
                var themeProperty = theme_1_1.value;
                if (typeof (themeProperty) !== undefined) {
                    themeWrapper.style.setProperty("--" + themeProperty.name, themeProperty.value);
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (theme_1_1 && !theme_1_1.done && (_a = theme_1.return)) _a.call(theme_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    /**
     * Apply specified style base on name and value provided
     * @param style style name
     * @param value style value
     */
    UbiAppshellService.prototype.setStyle = function (style, value, themeName) {
        if (themeName === void 0) { themeName = 'ubi-theme'; }
        var themeJson = JSON.parse(localStorage.getItem('ubi-themes'));
        themeJson[themeName][style] = value;
        localStorage.setItem('ubi-themes', JSON.stringify(themeJson));
        var themeWrapper = document.querySelector('html');
        themeWrapper.style.setProperty("--" + style, value);
    };
    /**
     * Listener of the theme change.
     */
    UbiAppshellService.prototype.onChange = function () {
        return this.onThemeChange$.asObservable();
    };
    /**
     * Get theme from LocalStorage.
     */
    UbiAppshellService.prototype.getTheme = function (themeName) {
        if (themeName === void 0) { themeName = 'ubi-theme'; }
        var themeString = JSON.parse(localStorage.getItem('ubi-themes'));
        if (themeString && themeString[themeName]) {
            return themeString[themeName];
        }
        else {
            this.setTheme([]);
            return [];
        }
    };
    UbiAppshellService = __decorate([
        Injectable(),
        __metadata("design:paramtypes", [])
    ], UbiAppshellService);
    return UbiAppshellService;
}());

var UbiAppshellModule = /** @class */ (function () {
    function UbiAppshellModule() {
    }
    UbiAppshellModule = __decorate([
        NgModule({
            imports: [
                CommonModule
            ],
            exports: [
                UbiMenuDirective,
                UbiAppshellComponent,
                UbiNavComponent,
                UbiContentComponent
            ],
            declarations: [
                UbiMenuDirective,
                UbiAppshellComponent,
                UbiNavComponent,
                UbiContentComponent
            ],
            providers: [
                UbiAppshellService
            ]
        })
    ], UbiAppshellModule);
    return UbiAppshellModule;
}());

var UbiDonutChartComponent = /** @class */ (function () {
    function UbiDonutChartComponent(changeDetector, ngZone) {
        this.changeDetector = changeDetector;
        this.ngZone = ngZone;
        // Deprecated parameter
        this.textColor = 'black';
        this._options = {
            chartFontColor: null,
            legendFontColor: '#286170',
            legendBackgroundColor: '#0b1f2a',
            dividerColor: '#286170'
        };
        // tslint:disable-next-line:no-output-rename
        this.click = new EventEmitter();
        this.circumference = 0;
        this.gap = 0;
        this.thickness = 40;
        this.cx = 150;
        this.cy = 150;
        this.angleOffset = 0;
        this.radius = 120;
        this.chartdataComputed = [];
        this.width = 300;
        this.height = 300;
        this.total = 0;
        this.svg = null;
        this.pie = null;
    }
    Object.defineProperty(UbiDonutChartComponent.prototype, "options", {
        set: function (options) {
            if (options) {
                this._options = Object.assign(this._options, options);
                this.refresh();
            }
        },
        enumerable: true,
        configurable: true
    });
    UbiDonutChartComponent.prototype.ngAfterViewInit = function () {
        this.width = this.chartContainer.nativeElement.offsetWidth;
        this.height = this.chartLegends.nativeElement.offsetHeight + 30;
        this.cx = this.width / 2;
        this.cy = this.height / 2;
        this.radius = Math.min(this.width, this.height) / 2 - 25;
        this.buildChart();
        this.changeDetector.detectChanges();
    };
    UbiDonutChartComponent.prototype.refresh = function () {
        if (!this.chartContainer || !this.chartLegends) {
            return;
        }
        this.width = this.chartContainer.nativeElement.offsetWidth;
        this.height = this.chartLegends.nativeElement.offsetHeight + 30;
        this.cx = this.width / 2;
        this.cy = this.height / 2;
        this.radius = Math.min(this.width, this.height) / 2 - 25;
        this.svg.selectAll('path').data(this.pie(this.chartData)).remove();
        this.svg.selectAll('text').remove();
        this.svg.selectAll('circle').remove();
        this.buildChart();
    };
    UbiDonutChartComponent.prototype.onResize = function (event) {
        if (this.svg) {
            this.svg.selectAll('path').data(this.pie(this.chartData)).remove();
            this.svg.selectAll('text').remove();
            this.refresh();
        }
    };
    UbiDonutChartComponent.prototype.ngOnInit = function () {
        this.chartData = this.mapData(this.chartData);
    };
    UbiDonutChartComponent.prototype.buildChart = function () {
        var e_1, _a;
        var _this = this;
        var data = this.selected;
        var tmp = 0;
        try {
            for (var _b = __values(this.chartData), _c = _b.next(); !_c.done; _c = _b.next()) {
                var i = _c.value;
                if (i.value) {
                    tmp += i.value;
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        this.total = tmp;
        this.pie = pie().padAngle(0.04).sort(null).value(function (d) { return d.value; });
        var arc$1 = arc()
            .innerRadius(this.radius - this.thickness)
            .outerRadius(this.radius);
        this.svg = select(this.donutSvg.nativeElement);
        this.svg.selectAll('path')
            .data(this.pie(this.chartData.filter(function (v) { return v.value; })))
            .enter()
            .append('path')
            .attr('fill', function (d, i) {
            if (data && JSON.stringify(data) !== JSON.stringify(d.data)) {
                return "url(" + location.pathname + "#gradient-gray";
            }
            else {
                return "url(" + location.pathname + "#gradient-" + d.data.id + ")";
            }
        })
            .attr('d', arc$1)
            .each(function (d) { this._current = d; })
            .attr('transform', "translate(" + this.cx + "," + this.cy + ")")
            .style('cursor', 'pointer')
            .on('click', function (d, i) {
            _this.svg.selectAll('path')
                .data(_this.pie(_this.chartData.filter(function (v) { return v.value; })))
                .attr('fill', function (innerData, index) {
                if (data && JSON.stringify(innerData.data) !== JSON.stringify(d.data)) {
                    return "url(" + location.pathname + "#gradient-gray";
                }
                else {
                    return "url(" + location.pathname + "#gradient-" + innerData.data.id + ")";
                }
            });
            _this.ngZone.run(function () {
                _this.selectItem(d.data);
            });
        })
            .transition()
            // .duration(1000)
            // .ease(d3.easeCubicInOut)
            .attrTween('d', function (d) {
            var interpolate$1 = interpolate(this._current, d);
            this._current = interpolate$1(1);
            return function (t) {
                return arc$1(interpolate$1(t));
            };
        });
        // .attrTween('d', function (d, index) {
        //   const i = d3.interpolate(d.startAngle + 0.1 + index * 10, d.endAngle);
        //   return function (t) {
        //     d.endAngle = i(t);
        //     return arc(d);
        //   };
        // });
        this.svg
            .append('circle')
            .attr('cx', this.cx)
            .attr('cy', this.cy)
            .attr('r', this.radius + 20)
            .attr('stroke', "url(" + location.pathname + "#gradient-ring)")
            .attr('stroke-width', 1)
            .attr('style', "filter:url(" + location.pathname + "#shadow)")
            .attr('fill', 'none');
        this.svg
            .append('text')
            .attr('fill', (this._options && this._options.chartFontColor ? this._options.chartFontColor : this.textColor))
            .attr('font-weight', 700)
            .attr('font-size', '50px')
            .attr('text-align', 'center')
            .attr('class', 'donut-chart_total')
            .attr('letter-spacing', '0.05em')
            .attr('text-anchor', 'middle')
            .attr('alignment-baseline', 'middle')
            .attr('x', this.width / 2).attr('y', this.height / 2)
            .text(this.total)
            .style('cursor', 'pointer')
            .on('click', function (d, i) {
            _this.svg.selectAll('path')
                .data(_this.pie(_this.chartData.filter(function (v) { return v.value; })))
                .attr('fill', function (innerData, index) {
                return "url(" + location.pathname + "#gradient-" + innerData.data.id + ")";
            });
            _this.ngZone.run(function () {
                _this.selectItem(null);
            });
        });
        this.svg
            .append('text')
            .attr('fill', (this._options && this._options.chartFontColor ? this._options.chartFontColor : this.textColor))
            .attr('font-weight', 400)
            .attr('font-size', '15px')
            .attr('class', 'donut-chart_title')
            .attr('letter-spacing', '.1em')
            .attr('text-anchor', 'middle')
            .attr('alignment-baseline', 'middle')
            .attr('x', this.width / 2).attr('y', this.height / 2 + 30)
            .text(this.chartTitle);
    };
    UbiDonutChartComponent.prototype.selectItem = function (item) {
        this.selected = item;
        this.svg.selectAll('path')
            .data(this.pie(this.chartData.filter(function (v) { return v.value; })))
            .attr('fill', function (innerData, index) {
            if (item && JSON.stringify(innerData.data) !== JSON.stringify(item)) {
                return "url(" + location.pathname + "#gradient-gray";
            }
            else {
                return "url(" + location.pathname + "#gradient-" + innerData.data.id + ")";
            }
        });
        this.click.emit(item);
        this.changeDetector.detectChanges();
    };
    UbiDonutChartComponent.prototype.mapData = function (data) {
        return data.map(function (d, index) {
            return __assign({}, d, { id: index });
        });
    };
    UbiDonutChartComponent.prototype.changeData = function (data) {
        this.chartData = this.mapData(data);
        this.selected = null;
        this.refresh();
    };
    UbiDonutChartComponent.ctorParameters = function () { return [
        { type: ChangeDetectorRef },
        { type: NgZone }
    ]; };
    __decorate([
        Input(),
        __metadata("design:type", Array)
    ], UbiDonutChartComponent.prototype, "chartData", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Number)
    ], UbiDonutChartComponent.prototype, "chartTotal", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], UbiDonutChartComponent.prototype, "chartTitle", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], UbiDonutChartComponent.prototype, "chartClass", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], UbiDonutChartComponent.prototype, "legendClass", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object)
    ], UbiDonutChartComponent.prototype, "textColor", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [Object])
    ], UbiDonutChartComponent.prototype, "options", null);
    __decorate([
        Output('onSelect'),
        __metadata("design:type", EventEmitter)
    ], UbiDonutChartComponent.prototype, "click", void 0);
    __decorate([
        ViewChild('donutSvg', { static: false }),
        __metadata("design:type", ElementRef)
    ], UbiDonutChartComponent.prototype, "donutSvg", void 0);
    __decorate([
        ViewChild('chartContainer', { static: false }),
        __metadata("design:type", ElementRef)
    ], UbiDonutChartComponent.prototype, "chartContainer", void 0);
    __decorate([
        ViewChild('chartLegends', { static: false }),
        __metadata("design:type", ElementRef)
    ], UbiDonutChartComponent.prototype, "chartLegends", void 0);
    __decorate([
        HostListener('window:resize', ['$event']),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], UbiDonutChartComponent.prototype, "onResize", null);
    UbiDonutChartComponent = __decorate([
        Component({
            selector: 'ubi-donut-chart',
            template: "<div class=\"donut-chart\">\n  <div #chartContainer class=\"{{chartClass}}\">\n    <svg #donutSvg id=\"donut-chart\" [attr.width]=\"width\" [attr.height]=\"height\">\n      <defs id=\"chart-gradients\">\n        <linearGradient id=\"gradient-gray\">\n          <stop offset=\"0%\" stop-color=\"#878787\" />\n          <stop offset=\"100%\" stop-color=\"#878787\" />\n        </linearGradient>\n        <linearGradient *ngFor=\"let item of chartData; let i = index\" id=\"gradient-{{item.id}}\">\n          <stop offset=\"0%\" [attr.stop-color]=\"item.color1\" />\n          <stop offset=\"100%\" [attr.stop-color]=\"item.color2\" />\n        </linearGradient>\n\n        <linearGradient id=\"gradient-ring\" x1=\"0%\" y1=\"00%\" x2=\"100%\" y2=\"100%\">\n          <stop offset=\"0%\" stop-color=\"rgb(200,200,255)\" stop-opacity=\"1\" />\n          <stop offset=\"30%\" stop-color=\"rgb(50,50,255)\" stop-opacity=\"0.2\" />\n          <stop offset=\"70%\" stop-color=\"rgb(50,50,255)\" stop-opacity=\"0.2\" />\n          <stop offset=\"100%\" stop-color=\"rgb(200,200,255)\" stop-opacity=\"1\" />\n        </linearGradient>\n        <filter id=\"shadow\">\n          <feDropShadow flood-color=\"#ffffff\" dx=\"0\" dy=\"0\" stdDeviation=\"4\" />\n        </filter>\n      </defs>\n    </svg>\n  </div>\n  <div id=\"pie-values\" class=\"{{ legendClass }}\" #chartLegends>\n    <div class=\"donut-chart__item\" *ngFor=\"let item of chartData; let i = index\" (click)=\"selectItem(item)\"\n      [style.color]=\"(selected && selected.id !== item.id) ? '#878787' : 'white'\">\n      <span [style.color]=\"_options?.legendFontColor\">{{ item.name }}</span>\n      <div class=\"donut-chart__number\" [style.color]=\"_options?.dividerColor\">\n        <span [style.color]=\"_options?.legendFontColor\">{{ item.value ? item.value : 0 }}</span>\n      </div>\n      <div class=\"donut-chart__bar\" [style.background-color]=\"_options?.legendBackgroundColor\">\n        <div class=\"donut-chart__color\" style=\"height:100%;\"\n          [style.background-image]=\"(selected && selected.id !== item.id) ? 'linear-gradient(to right,#878787,#878787)' : 'linear-gradient(to right,'+item.color1 + ',' +item.color2+ ')'\"\n          [style.width]=\"((total && item.value) ? item.value/total*100 : 0) + '%'\">\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n",
            styles: [".donut-chart__total{font-weight:700;font-size:50px;text-align:center;letter-spacing:.05em}.donut-chart__item{cursor:pointer}.donut-chart__title{font-weight:400;font-size:15px;text-transform:uppercase;letter-spacing:.1em}.donut-chart__side-left{max-width:60%;flex-basis:60%}.donut-chart__side-right{max-width:320px;flex-basis:40%}"]
        }),
        __metadata("design:paramtypes", [ChangeDetectorRef,
            NgZone])
    ], UbiDonutChartComponent);
    return UbiDonutChartComponent;
}());

var UbiDonutChartModule = /** @class */ (function () {
    function UbiDonutChartModule() {
    }
    UbiDonutChartModule = __decorate([
        NgModule({
            imports: [
                CommonModule
            ],
            declarations: [UbiDonutChartComponent],
            exports: [UbiDonutChartComponent],
        })
    ], UbiDonutChartModule);
    return UbiDonutChartModule;
}());

var UbiThemeChangeEvent = /** @class */ (function () {
    function UbiThemeChangeEvent() {
    }
    return UbiThemeChangeEvent;
}());
var UbiThemeItem = /** @class */ (function () {
    function UbiThemeItem() {
    }
    return UbiThemeItem;
}());
var UbiThemeOption = /** @class */ (function () {
    function UbiThemeOption(data) {
        this.themeName = 'ubi-theme';
        this.themeName = data.themeName;
        this.options = data.options;
    }
    return UbiThemeOption;
}());
function DEFAULT_THEME_OPTIONS() {
    return new UbiThemeOption({ themeName: 'ubi-theme', options: [] });
}
var UBI_THEME_OPTIONS = new InjectionToken('UBI_THEME_OPTIONS', {
    providedIn: 'root',
    factory: DEFAULT_THEME_OPTIONS
});

var UbiPrebuildTheme = ['ubi-light', 'ubi-dark'];
var UbiThemifyService = /** @class */ (function () {
    function UbiThemifyService(ubiThemeService, defaultStyles, overlayContainer) {
        this.ubiThemeService = ubiThemeService;
        this.defaultStyles = defaultStyles;
        this.overlayContainer = overlayContainer;
        this.ubiChange$ = new EventEmitter();
        this.styleText = '';
        this.styleJson = [];
        this.themeName = this.defaultStyles.themeName;
        var option = this.merge(this.defaultStyles.options, this.ubiThemeService.getTheme(this.themeName), 'name');
        this.styleJson = option;
        this.ubiThemeService.setTheme(option, this.themeName);
        this.updateText();
    }
    UbiThemifyService.prototype.merge = function (arr1, arr2, key) {
        var merged = [];
        var _loop_1 = function (i) {
            merged.push(__assign({}, arr1[i], (arr2.find(function (itmInner) { return itmInner[key] === arr1[i][key]; }))));
        };
        for (var i = 0; i < arr1.length; i++) {
            _loop_1(i);
        }
        return merged;
    };
    UbiThemifyService.prototype.convertToKeyValuePair = function (options, key, value) {
        var e_1, _a;
        var results = {};
        try {
            for (var options_1 = __values(options), options_1_1 = options_1.next(); !options_1_1.done; options_1_1 = options_1.next()) {
                var i = options_1_1.value;
                results[i[key]] = i[value];
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (options_1_1 && !options_1_1.done && (_a = options_1.return)) _a.call(options_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return results;
    };
    UbiThemifyService.prototype.updateText = function () {
        var e_2, _a;
        this.styleText = '';
        try {
            for (var _b = __values(this.styleJson), _c = _b.next(); !_c.done; _c = _b.next()) {
                var el = _c.value;
                if (el) {
                    this.styleText += el.name + ": " + el.value + "\n";
                }
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_2) throw e_2.error; }
        }
    };
    UbiThemifyService.prototype.convertJsonToText = function (json) {
        var e_3, _a;
        var styleText = '';
        try {
            for (var json_1 = __values(json), json_1_1 = json_1.next(); !json_1_1.done; json_1_1 = json_1.next()) {
                var el = json_1_1.value;
                if (el) {
                    styleText += el.name + ": " + el.value + "\n";
                }
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (json_1_1 && !json_1_1.done && (_a = json_1.return)) _a.call(json_1);
            }
            finally { if (e_3) throw e_3.error; }
        }
        return styleText;
    };
    UbiThemifyService.prototype.change = function () {
        return this.ubiChange$.asObservable();
    };
    UbiThemifyService.prototype.getThemeName = function () {
        return this.themeName;
    };
    UbiThemifyService.prototype.getStyleJson = function () {
        return this.styleJson;
    };
    UbiThemifyService.prototype.getStyleText = function () {
        return this.styleText;
    };
    UbiThemifyService.prototype.updateStyle = function (name, value) {
        var style = this.styleJson.find(function (i) { return i.name === name; });
        style.value = value;
        this.ubiThemeService.setTheme(this.styleJson, this.themeName);
        this.updateText();
        this.ubiChange$.emit({
            json: this.styleJson,
            text: this.styleText,
            themeName: this.themeName
        });
    };
    UbiThemifyService.prototype.setStyle = function (styleText) {
        var _this = this;
        this.styleText = styleText;
        styleText.split('\n').forEach(function (line) {
            if (line) {
                var props_1 = line.split(':');
                var found = _this.styleJson.find(function (i) { return i.name === props_1[0].trim(); });
                found.value = props_1[1].trim();
            }
        });
        this.ubiThemeService.setTheme(this.styleJson, this.themeName);
        this.updateText();
        this.ubiChange$.emit({
            json: this.styleJson,
            text: this.styleText,
            themeName: this.themeName
        });
    };
    UbiThemifyService.prototype.changeTheme = function (theme) {
        this.themeName = theme;
        this.ubiChange$.emit({
            json: this.styleJson,
            text: this.styleText,
            themeName: theme
        });
    };
    UbiThemifyService.prototype.useTheme = function (themeName) {
        var _this = this;
        UbiPrebuildTheme.forEach(function (i) {
            _this.overlayContainer.getContainerElement().classList.remove(i);
            document.querySelector('html').classList.remove(i);
        });
        this.overlayContainer.getContainerElement().classList.remove(this.defaultStyles.themeName);
        this.overlayContainer.getContainerElement().classList.add(themeName);
        document.querySelector('html').classList.remove(this.defaultStyles.themeName);
        document.querySelector('html').classList.add(themeName);
        this.themeName = themeName;
    };
    UbiThemifyService.ctorParameters = function () { return [
        { type: UbiAppshellService },
        { type: UbiThemeOption, decorators: [{ type: Inject, args: [UBI_THEME_OPTIONS,] }] },
        { type: OverlayContainer }
    ]; };
    UbiThemifyService = __decorate([
        Injectable(),
        __param(1, Inject(UBI_THEME_OPTIONS)),
        __metadata("design:paramtypes", [UbiAppshellService, UbiThemeOption,
            OverlayContainer])
    ], UbiThemifyService);
    return UbiThemifyService;
}());

var UbiThemifyComponent = /** @class */ (function () {
    function UbiThemifyComponent(themifyService, customTheme) {
        this.themifyService = themifyService;
        this.customTheme = customTheme;
        this.isSidebar = false;
    }
    UbiThemifyComponent.prototype.ngOnInit = function () {
        this.defaultStyles = this.themifyService.getStyleJson();
        this.defaultThemeName = this.customTheme.themeName;
        this.styles = this.themifyService.getStyleText();
    };
    UbiThemifyComponent.prototype.changeStyle = function (name, $event) {
        this.themifyService.updateStyle(name, $event.target.value);
        this.defaultStyles = this.themifyService.getStyleJson();
        this.styles = this.themifyService.getStyleText();
    };
    // toggleTheme() {
    //   this.isChangeTheme = !this.isChangeTheme;
    // }
    UbiThemifyComponent.prototype.changeTheme = function (name) {
        this.themifyService.useTheme(name);
    };
    UbiThemifyComponent.prototype.editTheme = function (optionText) {
        this.themifyService.setStyle(optionText);
    };
    UbiThemifyComponent.prototype.ngOnChanges = function (changes) {
        if (changes['defaultStyles']) {
            // this.styles = this.themifyService.convertJsonToText(changes['defaultStyles']);
            // this.themifyService.editStyle(this.styles);
        }
    };
    UbiThemifyComponent.prototype.toggleSidebar = function () {
        // const body = document.getElementsByTagName('body')[0];
        this.isSidebar = !this.isSidebar;
        // if (!this.isSidebar) {
        //   // body.classList.add('ubi-shown');
        //   this.isSidebar = !this.isSidebar;
        // } else {
        //   // body.classList.remove('ubi-shown');
        //   this.isSidebar = false;
        // }
    };
    UbiThemifyComponent.ctorParameters = function () { return [
        { type: UbiThemifyService },
        { type: UbiThemeOption, decorators: [{ type: Inject, args: [UBI_THEME_OPTIONS,] }] }
    ]; };
    UbiThemifyComponent = __decorate([
        Component({
            selector: 'ubi-themify',
            template: "<!-- <div [ngClass]=\"isChangeTheme ? 'success' : ''\" class=\"change-theme\"> -->\n<div>\n  <div class=\"overlay\" (click)=\"toggleSidebar()\" *ngIf=\"isSidebar\"></div>\n  <div class=\"change-theme\" [ngClass]=\"isSidebar ? 'change-theme_opened' : ''\">\n    <div class=\"navbar__theme\">\n      <button mat-menu-item class=\"btn-color btn-light\" (click)=\"changeTheme('ubi-light')\"></button>\n      <button mat-menu-item class=\"btn-color btn-dark\" (click)=\"changeTheme('ubi-dark')\"></button>\n      <button mat-menu-item class=\"btn-text btn-light\" (click)=\"changeTheme(defaultThemeName)\">Custom</button>\n    </div>\n    <div class=\"ubi-theme\">\n      <div class=\"ubi-item\">\n        <div class=\"ubi-color\" *ngFor=\"let style of defaultStyles\">\n          <label>{{style.title}}</label>\n          <input [(ngModel)]=\"style.value\" [type]=\"style.type\" (change)=\"changeStyle(style.name,$event)\" />\n        </div>\n        <!-- <div class=\"ubi-color\">\n          <label>NavBar Font Color: </label>\n          <input ubiUbiAppshell [stytes]=\"'navColor'\" [value]=\"defaultStyles.navColor\" type=\"color\" />\n        </div> -->\n      </div>\n      <!-- <div class=\"ubi-item\">\n        <div class=\"ubi-color\">\n          <label>Sidebar Header Color: </label>\n          <input ubiUbiAppshell [stytes]=\"'sidebarHeaderColor'\" [value]=\"defaultStyles.sidebarHeaderColor\"\n            type=\"color\" />\n        </div>\n        <div class=\"ubi-color\">\n          <label>Sidebar Color: </label>\n          <input ubiUbiAppshell [stytes]=\"'sidebarColor'\" [value]=\"defaultStyles.sidebarColor\" type=\"color\" />\n        </div>\n      </div>\n      <div class=\"ubi-item\">\n        <div class=\"ubi-color\">\n          <label>Card Background: </label>\n          <input ubiUbiAppshell [stytes]=\"'cardBackground'\" [value]=\"defaultStyles.cardBackground\" type=\"color\" />\n        </div>\n        <div class=\"ubi-color\">\n          <label>Card Header Color: </label>\n          <input ubiUbiAppshell [stytes]=\"'cardHeaderColor'\" [value]=\"defaultStyles.cardHeaderColor\" type=\"color\" />\n        </div>\n        <div class=\"ubi-color\">\n          <label>Card Color: </label>\n          <input ubiUbiAppshell [stytes]=\"'cardColor'\" [value]=\"defaultStyles.cardColor\" type=\"color\" />\n        </div>\n      </div> -->\n      <div class=\"ubi-item\">\n        <!-- <div class=\"ubi-color\">\n          <label>Button Background: </label>\n          <input ubiUbiAppshell [stytes]=\"'buttonBackground'\" [value]=\"defaultStyles.buttonBackground\" type=\"color\" />\n        </div>\n        <div class=\"ubi-color\">\n          <label>Button Color: </label>\n          <input ubiUbiAppshell [stytes]=\"'buttonColor'\" [value]=\"defaultStyles.buttonColor\" type=\"color\" />\n        </div> -->\n        <div class=\"ubi-color\">\n          <textarea rows=\"4\" cols=\"50\" #styleEditor>{{styles}}</textarea>\n        </div>\n        <button mat-stroked-button class=\"btn-large\" (click)=\"editTheme(styleEditor.value)\">Change Theme</button>\n      </div>\n    </div>\n  </div>\n</div>\n",
            styles: [".header{width:100%;padding:15px 50px}.navbar{display:-webkit-box;display:flex;-webkit-box-align:center;align-items:center}.navbar__link{padding:0 15px;font-weight:300;font-size:.9rem;text-decoration:none;letter-spacing:.05em}.navbar__link:first-child{padding-left:0}.navbar__link:last-child{padding-right:0}.navbar__icon{display:-webkit-box;display:flex;-webkit-box-align:center;align-items:center}.navbar__icon svg{margin-right:8px}.navbar__logo{font-weight:500}.navbar__theme{display:-webkit-box;display:flex;-webkit-box-pack:start;justify-content:flex-start;-webkit-box-align:center;align-items:center;padding:0 10px}.navbar__theme .btn-color{display:-webkit-box;display:flex;-webkit-box-pack:center;justify-content:center;-webkit-box-align:center;align-items:center;position:relative;width:90px;height:40px;border:0;padding:0;outline:0;cursor:pointer}.navbar__theme .btn-color::before{content:'';width:80px;height:33px;border:1px solid #ddd;background-color:#fff}.navbar__theme .btn-text{display:-webkit-box;display:flex;-webkit-box-pack:center;justify-content:center;-webkit-box-align:center;align-items:center;position:relative;width:80px;height:33px;border:1px solid #ddd;padding:0;outline:0;cursor:pointer}.navbar__theme .btn-dark::before{background-color:#000}.navbar__mobile{display:-webkit-box;display:flex;-webkit-box-align:center;align-items:center}.flex-spacer{-webkit-box-flex:1;flex-grow:1}.change-theme{position:fixed;z-index:9;top:0;right:0;bottom:0;width:300px;height:100%;border-left:1px solid #ccc;padding:20px 15px;background-color:#fff;-webkit-transform:translateX(400px);transform:translateX(400px);-webkit-transition:.5s;transition:.5s}.change-theme_opened{-webkit-transform:translateX(0);transform:translateX(0)}.overlay{position:fixed;top:0;left:0;width:100%;height:100%;background-color:transparent}textarea{max-width:100%;height:100px}@media (max-width:767px){.header{padding:15px 30px}}.ubi-theme{padding:15px}.ubi-theme .ubi-item{border-bottom:1px solid #eee;padding:8px 0;font-size:.8rem;letter-spacing:.1em}.ubi-theme label{display:inline-block;min-width:200px;padding-right:10px}.ubi-theme .action{margin-top:20px}.ubi-color{display:-webkit-box;display:flex;-webkit-box-pack:justify;justify-content:space-between;-webkit-box-align:center;align-items:center;padding:5px 0}"]
        }),
        __param(1, Inject(UBI_THEME_OPTIONS)),
        __metadata("design:paramtypes", [UbiThemifyService,
            UbiThemeOption])
    ], UbiThemifyComponent);
    return UbiThemifyComponent;
}());

var UbiThemifyModule = /** @class */ (function () {
    function UbiThemifyModule(parentModule) {
        if (parentModule) {
            throw new Error('CoreModule is already loaded. Import it in the AppModule only');
        }
    }
    UbiThemifyModule_1 = UbiThemifyModule;
    UbiThemifyModule.forRoot = function (config) {
        return {
            ngModule: UbiThemifyModule_1,
            providers: [
                UbiThemifyService,
                {
                    provide: UBI_THEME_OPTIONS,
                    useValue: config
                }
            ]
        };
    };
    var UbiThemifyModule_1;
    UbiThemifyModule.ctorParameters = function () { return [
        { type: UbiThemifyModule, decorators: [{ type: Optional }, { type: SkipSelf }] }
    ]; };
    UbiThemifyModule = UbiThemifyModule_1 = __decorate([
        NgModule({
            imports: [
                // UbiAppshellModule,
                CommonModule,
                FormsModule
            ],
            declarations: [
                UbiThemifyComponent
            ],
            exports: [
                UbiThemifyComponent
            ]
        }),
        __param(0, Optional()), __param(0, SkipSelf()),
        __metadata("design:paramtypes", [UbiThemifyModule])
    ], UbiThemifyModule);
    return UbiThemifyModule;
}());

var UbiIdleLocalStorageKeys;
(function (UbiIdleLocalStorageKeys) {
    UbiIdleLocalStorageKeys["lastActive"] = "ubiIdleUserLastActive";
    UbiIdleLocalStorageKeys["authState"] = "ubiAuthenticationBrowserSync";
})(UbiIdleLocalStorageKeys || (UbiIdleLocalStorageKeys = {}));

var UbiIdleService = /** @class */ (function () {
    function UbiIdleService() {
        this.authState$ = new BehaviorSubject(null);
        this.unsubscribe$ = new ReplaySubject(1);
    }
    UbiIdleService.prototype.pollingToSyncDifferentTabs = function () {
        var _this = this;
        interval(3000)
            .pipe(takeUntil(this.unsubscribe$)).subscribe(function () {
            _this.synchronizeAuthState();
            _this.synchronizeLastActive();
            if (_this.isLogged) {
                _this.updateCountDown();
            }
        });
    };
    UbiIdleService.prototype.updateCountDown = function () {
        this.countDown -= 3000;
        if (this.countDown < 0) {
            this.config.onTimeout();
            localStorage.removeItem(UbiIdleLocalStorageKeys.lastActive);
            this.isLogged = false;
        }
    };
    UbiIdleService.prototype.userEventsSubscriber = function () {
        var _this = this;
        merge(fromEvent(window, 'click'), fromEvent(window, 'wheel'), fromEvent(window, 'keypress')).pipe(throttleTime(3000), // debounce user event
        takeUntil(this.unsubscribe$), filter(function () { return _this.isLogged; }) // check logged
        ).subscribe(function () {
            localStorage.setItem(UbiIdleLocalStorageKeys.lastActive, new Date().getTime() + '');
            _this.resetCountDown();
        });
    };
    UbiIdleService.prototype.synchronizeAuthState = function () {
        var lastState = localStorage.getItem(UbiIdleLocalStorageKeys.authState);
        // Just logged out with clear localStorage or not logged in yet
        if ((!lastState && !this.previousAuthState) || (lastState === this.previousAuthState)) {
            return;
        }
        // Just logged out with clear localStorage or not logged in yet
        if (!lastState || lastState === 'signedOut') {
            this.previousAuthState = lastState;
            this.authState$.next('signedOut');
            this.isLogged = false;
            this.resetCountDown();
            localStorage.removeItem(UbiIdleLocalStorageKeys.lastActive);
        }
        else if (lastState === 'signedIn') { // AuthState changed at another tabs
            this.authState$.next(lastState);
            this.previousAuthState = lastState;
            this.isLogged = true;
        }
    };
    UbiIdleService.prototype.synchronizeLastActive = function () {
        var lastActive = localStorage.getItem(UbiIdleLocalStorageKeys.lastActive);
        // Just logged out with clear localStorage, not logged in yet, user never actived
        if (!lastActive || lastActive === this.previousActive) {
            return;
        }
        this.previousActive = lastActive;
        var lastActiveNum = +lastActive;
        var timestamp = new Date().getTime() - lastActiveNum;
        this.countDown = this.config.sessionTimeout - timestamp;
    };
    UbiIdleService.prototype.resetCountDown = function () {
        this.countDown = this.config.sessionTimeout;
    };
    UbiIdleService.prototype.init = function (config) {
        this.config = config;
        this.countDown = this.config.sessionTimeout;
        this.previousAuthState = localStorage.getItem(UbiIdleLocalStorageKeys.authState);
        this.pollingToSyncDifferentTabs();
        this.userEventsSubscriber();
    };
    UbiIdleService.prototype.setBrowserLogin = function () {
        this.isLogged = true;
        localStorage.setItem(UbiIdleLocalStorageKeys.authState, 'signedIn');
    };
    UbiIdleService.prototype.setBrowserLogout = function () {
        this.isLogged = false;
        this.resetCountDown();
        localStorage.setItem(UbiIdleLocalStorageKeys.authState, 'signedOut');
        localStorage.removeItem(UbiIdleLocalStorageKeys.lastActive);
    };
    UbiIdleService.prototype.getAuthState = function () {
        return this.authState$.asObservable();
    };
    UbiIdleService.prototype.setAuthState = function (state) {
        this.previousAuthState = state;
    };
    UbiIdleService.prototype.clear = function () {
        this.unsubscribe$.next(null);
        this.unsubscribe$.complete();
    };
    UbiIdleService.ngInjectableDef = ɵɵdefineInjectable({ factory: function UbiIdleService_Factory() { return new UbiIdleService(); }, token: UbiIdleService, providedIn: "root" });
    UbiIdleService = __decorate([
        Injectable({
            providedIn: 'root'
        }),
        __metadata("design:paramtypes", [])
    ], UbiIdleService);
    return UbiIdleService;
}());

var UbiIdleModule = /** @class */ (function () {
    // https://angular.io/guide/singleton-services#prevent-reimport-of-the-coremodule
    function UbiIdleModule(parentModule) {
        if (parentModule) {
            throw new Error('UbiIdleModule is already loaded. Import it in the AppModule only');
        }
    }
    UbiIdleModule_1 = UbiIdleModule;
    UbiIdleModule.forRoot = function () {
        return {
            ngModule: UbiIdleModule_1,
            providers: [
                UbiIdleService
            ]
        };
    };
    var UbiIdleModule_1;
    UbiIdleModule.ctorParameters = function () { return [
        { type: UbiIdleModule, decorators: [{ type: Optional }, { type: SkipSelf }] }
    ]; };
    UbiIdleModule = UbiIdleModule_1 = __decorate([
        NgModule({
            imports: [
                CommonModule
            ]
        }),
        __param(0, Optional()), __param(0, SkipSelf()),
        __metadata("design:paramtypes", [UbiIdleModule])
    ], UbiIdleModule);
    return UbiIdleModule;
}());

/*
 * Public API Surface of uber-ui
 */

/**
 * Generated bundle index. Do not edit.
 */

export { COGNITO_CHALLENGES, COGNITO_ERROR_CODE, DEFAULT_THEME_OPTIONS, FingerPrintService, LocalStorageService, StepperEventType, UBI_THEME_OPTIONS, UberUiModule, UbiAppshellComponent, UbiAppshellModule, UbiAuthCustomOAuthService, UbiAuthDappMetaMaskService, UbiAuthDappPrivateKeyService, UbiAuthFactory, UbiAuthFakeIdentity, UbiAuthFakeTwoFA, UbiAuthISOCognitoUsernamePasswordService, UbiAuthIdentityProvider, UbiAuthModule, UbiAuthStateType, UbiAuthTwoFAProvider, UbiDialogComponent, UbiDialogModule, UbiDialogService, UbiDonutChartComponent, UbiDonutChartModule, UbiIdleModule, UbiIdleService, UbiPaginationComponent, UbiPaginationModule, UbiPieChartComponent, UbiPieChartModule, UbiPrebuildTheme, UbiStepComponent, UbiStepperComponent, UbiStepperModule, UbiStepperService, UbiThemeChangeEvent, UbiThemeItem, UbiThemeOption, UbiThemifyComponent, UbiThemifyModule, UbiThemifyService, UbiMaterialModule as ɵa, CurveHeaderComponent as ɵb, RoundButtonDirective as ɵc, UbiMenuDirective as ɵd, UbiNavComponent as ɵe, UbiContentComponent as ɵf, UbiAppshellService as ɵg };
//# sourceMappingURL=uber-ui.js.map
